// import React, { useState, useEffect, useRef } from "react";
// import {
//   Box,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Chip,
//   IconButton,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Typography,
//   Grid,
//   Alert,
//   Snackbar,
//   Tooltip,
//   CircularProgress,
//   InputAdornment,
//   TableSortLabel,
//   Stack,
//   Divider,
//   Avatar,
//   Menu,
// } from "@mui/material";
// import {
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Refresh as RefreshIcon,
//   DateRange as DateRangeIcon,
//   CheckCircle as CheckCircleIcon,
//   Cancel as CancelIcon,
//   Pending as PendingIcon,
//   LocalShipping as ShippingIcon,
//   DoneAll as DeliveredIcon,
//   Timeline as TimelineIcon,
//   ShoppingCart as CartIcon,
//   LocalOffer as OfferIcon,
//   Payment as PaymentIcon,
//   Search as SearchIcon,
//   CurrencyExchange as RefundIcon,
//   DirectionsBike as DirectionsBikeIcon
// } from "@mui/icons-material";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { format } from "date-fns";
// import RestaurantIcon from "@mui/icons-material/Restaurant";
// import TakeoutDiningIcon from "@mui/icons-material/TakeoutDining";
// import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";

// // Redux imports
// import { useDispatch, useSelector } from "react-redux";
// import { useSocket } from "../../context/SocketContext";
// import {
//   fetchAllOrders,
//   changeOrderStatus,
//   updateOrderDetails,
//   cancelOrder,
//   fetchOrderStats,
//   clearError,
//   clearSuccess,
//   setFilters,
// } from "../../redux/slices/orderSlice";
// import {
//   getPayments,
//   updatePaymentStatus,
//   selectPayments,
//   selectPaymentsLoading,
//   selectPaymentsPagination,
// } from "../../redux/slices/paymentsSlice";

// import axiosInstance from "../../utils/axios";

// const Orders = () => {
//   const dispatch = useDispatch();
//   const { socket, isConnected } = useSocket();
//   const { orders, loading, error, success, totalOrders, filters } = useSelector(
//     (state) => state.order,
//   );
//   const payments = useSelector(selectPayments);

//   // Local states
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [openViewDialog, setOpenViewDialog] = useState(false);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
//   const [openStatusDialog, setOpenStatusDialog] = useState(false);
//   const [openDateRangeDialog, setOpenDateRangeDialog] = useState(false);
//   const [openPaymentStatusDialog, setOpenPaymentStatusDialog] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchOpen, setSearchOpen] = useState(false);
//   const [notification, setNotification] = useState(null);

//   const [orderData, setOrderData] = useState({
//     name: "",
//     phone: "",
//     address: "",
//     items: [],
//     deliveryCharge: 0,
//     totalAmount: 0,
//     notes: "",
//   });
//   const [newStatus, setNewStatus] = useState("");
//   const [newPaymentStatus, setNewPaymentStatus] = useState("");
//   const [dateRange, setDateRange] = useState({
//     startDate: null,
//     endDate: null,
//   });
//   const [sortConfig, setSortConfig] = useState({
//     field: "createdAt",
//     direction: "desc",
//   });

//   const [anchorEl, setAnchorEl] = useState(null);
//   const [selectedPayment, setSelectedPayment] = useState(null);

//   // const statusOptions = [
//   //   { value: "PENDING", label: "Pending", color: "warning" },
//   //   { value: "ACCEPTED", label: "Accepted", color: "info" },
//   //   { value: "PREPARING", label: "Processing", color: "secondary" },
//   //   { value: "OUT_FOR_DELIVERY", label:"Out for Delivery", color: "info" },
//   //   { value: "COMPLETED", label: "Completed", color: "primary" },
//   //   { value: "DELIVERED", label: "Delivered", color: "success" },
//   //   { value: "CANCELLED", label: "Cancelled", color: "error" },
//   // ];

//   // Line 5601 par:
//   const statusOptions = [
//     { value: "PENDING", label: "Pending", color: "warning" },
//     { value: "ACCEPTED", label: "Accepted", color: "info" },
//     { value: "PREPARING", label: "Processing", color: "secondary" },
//     { value: "OUT_FOR_DELIVERY", label: "Out For Delivery", color: "warning" }, // 👈 ADD THIS
//     { value: "COMPLETED", label: "Completed", color: "primary" },
//     { value: "DELIVERED", label: "Delivered", color: "success" },
//     { value: "CANCELLED", label: "Cancelled", color: "error" },
//   ];



//   // ⭐ Payment status options with REFUND_PENDING
//   const paymentStatusOptions = [
//     { value: "PENDING", label: "Pending", color: "warning" },
//     { value: "PAID", label: "Paid", color: "success" },
//     { value: "FAILED", label: "Failed", color: "error" },
//     { value: "REFUND_PENDING", label: "Refund Pending", color: "error" },
//     { value: "REFUNDED", label: "Refunded", color: "info" },
//   ];

//   const orderTypeOptions = [
//     {
//       value: "DINE_IN",
//       label: "Dine In",
//       color: "success",
//       icon: <RestaurantIcon fontSize="small" />,
//     },
//     {
//       value: "TAKEAWAY",
//       label: "Takeaway",
//       color: "secondary",
//       icon: <TakeoutDiningIcon fontSize="small" />,
//     },
//     {
//       value: "DELIVERY",
//       label: "Delivery",
//       color: "error",
//       icon: <DeliveryDiningIcon fontSize="small" />,
//     },
//   ];

//   const paymentMethodOptions = [
//     { value: "CASH", label: "Cash", icon: "💵", color: "#2E7D32" },
//     { value: "UPI", label: "UPI", icon: "📱", color: "#1565C0" },
//     { value: "PHONEPE", label: "PHONEPE", icon: "💳", color: "#5E35B1" },
//     { value: "ONLINE", label: "Online", icon: "🌐", color: "#EF6C00" },
//     { value: "WALLET", label: "Wallet", icon: "👛", color: "#C2185B" },
//   ];

//   const getOrderTotal = (order) => {
//     return order.orderSummary?.totalAmount || order.totalAmount || 0;
//   };

//   const getOrderSubtotal = (order) => {
//     return order.orderSummary?.subtotal || order.totalAmount || 0;
//   };

//   const getOrderDiscount = (order) => {
//     return order.orderSummary?.totalDiscount || 0;
//   };

//   const getOrderDeliveryCharge = (order) => {
//     return Number(
//       order.orderSummary?.deliveryCharge ?? order.deliveryCharge ?? 0,
//     );
//   };

//   const getOrderPayment = (orderId) => {
//     return payments?.find(
//       (p) => p.order?._id === orderId || p.order === orderId,
//     );
//   };

//   const getPaymentStatusChip = (status) => {
//     const statusOption = paymentStatusOptions.find(
//       (opt) => opt.value === status,
//     );
//     return (
//       <Chip
//         label={statusOption?.label || status}
//         color={statusOption?.color || "default"}
//         size="small"
//         icon={
//           status === "REFUND_PENDING" ? (
//             <RefundIcon sx={{ fontSize: "14px !important" }} />
//           ) : (
//             <PaymentIcon />
//           )
//         }
//         sx={{ fontWeight: 600, minWidth: 80 }}
//       />
//     );
//   };

//   const getPaymentMethodChip = (method) => {
//     const methodOption = paymentMethodOptions.find(
//       (opt) => opt.value === method,
//     );
//     return (
//       <Chip
//         label={methodOption?.label || method}
//         size="small"
//         sx={{
//           fontWeight: 500,
//           backgroundColor: methodOption?.color || "#e0e0e0",
//           color: "#fff",
//           "& .MuiChip-icon": { color: "#fff" },
//         }}
//       />
//     );
//   };

//   const calculateItemTotal = (item) => {
//     const basePrice = item.selectedSize?.price || item.price || 0;
//     const variantPrice = item.selectedVariant?.price || 0;
//     const addonsTotal =
//       item.selectedAddons?.reduce((sum, a) => sum + (a.price || 0), 0) || 0;
//     return (basePrice + variantPrice + addonsTotal) * (item.quantity || 1);
//   };

//   const calculateTotalItems = (items) => {
//     return items?.reduce((total, item) => total + (item.quantity || 0), 0) || 0;
//   };

//   const calculateTotalAmount = (items, deliveryCharge = 0) => {
//     const itemsTotal =
//       items?.reduce((total, item) => {
//         return total + (item.total || calculateItemTotal(item));
//       }, 0) || 0;
//     return itemsTotal + Number(deliveryCharge || 0);
//   };

//   const formatDate = (dateString) => {
//     return format(new Date(dateString), "dd/MM/yyyy HH:mm");
//   };

//   const formatCurrency = (amount) => {
//     return `₹${Number(amount || 0).toFixed(2)}`;
//   };

//   // getStatusIcon function to return the appropriate icon based on the order status
//   const getStatusIcon = (status) => {
//     switch (status) {
//       case "PENDING":
//         return <PendingIcon />;
//       case "ACCEPTED":
//         return <CheckCircleIcon />;
//       case "PREPARING":
//         return <TimelineIcon />;
//       case "OUT_FOR_DELIVERY":
//         return <DeliveryDiningIcon />; // 👈 ADD THIS
//       case "COMPLETED":
//         return <ShippingIcon />;
//       case "DELIVERED":
//         return <DeliveredIcon />;
//       case "CANCELLED":
//         return <CancelIcon />;
//       default:
//         return null;
//     }
//   };

//   const getStatusChip = (status) => {
//     const statusOption = statusOptions.find((opt) => opt.value === status);
//     return (
//       <Chip
//         label={statusOption?.label || status}
//         color={statusOption?.color || "default"}
//         size="small"
//         icon={getStatusIcon(status)}
//         sx={{ fontWeight: 600, minWidth: 90 }}
//       />
//     );
//   };

//   const getOrderTypeChip = (orderType) => {
//     const selectedType = orderTypeOptions.find(
//       (opt) => opt.value === orderType,
//     );
//     return (
//       <Chip
//         icon={selectedType?.icon}
//         label={selectedType?.label || orderType}
//         color={selectedType?.color || "default"}
//         size="small"
//         variant="filled"
//         sx={{ fontWeight: 600, minWidth: 90 }}
//       />
//     );
//   };

//   const fetchOrders = async (showLoading = true, searchParams = null) => {
//     try {
//       const params = searchParams || filters;
//       if (showLoading) {
//         await dispatch(fetchAllOrders(params));
//         await dispatch(getPayments({ page: 1, limit: 100 }));
//       } else {
//         await dispatch(fetchAllOrders(params));
//       }
//     } catch (error) {
//       console.error("Fetch orders error:", error);
//     }
//   };

//   const handleSearch = (e) => {
//     const query = e.target.value;
//     setSearchQuery(query);
//     const updatedFilters = {
//       ...filters,
//       search: query,
//       page: 1,
//     };
//     dispatch(setFilters(updatedFilters));
//     setPage(0);
//   };

//   const handleSearchToggle = () => {
//     setSearchOpen(!searchOpen);
//     if (searchOpen) {
//       setSearchQuery("");
//       const updatedFilters = {
//         ...filters,
//         search: "",
//         page: 1,
//       };
//       dispatch(setFilters(updatedFilters));
//       setPage(0);
//     }
//   };

//   const getFilteredOrders = () => {
//     if (!searchQuery.trim()) return orders;
//     const query = searchQuery.toLowerCase().trim();
//     return orders?.filter((order) => {
//       const orderIdLast8 = order._id?.slice(-8).toUpperCase() || "";
//       if (orderIdLast8.includes(query.toUpperCase())) return true;
//       if (order._id?.toLowerCase().includes(query)) return true;
//       if (order.customer?.name?.toLowerCase().includes(query)) return true;
//       if (order.customer?.phone?.includes(query)) return true;
//       if (
//         order.items?.some((item) =>
//           item.itemName?.toLowerCase().includes(query),
//         )
//       )
//         return true;
//       return false;
//     });
//   };

//   const displayedOrders = getFilteredOrders();

//   const handleManualRefresh = () => {
//     fetchOrders(true, filters);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//     const updatedFilters = { ...filters, page: newPage + 1 };
//     dispatch(setFilters(updatedFilters));
//     fetchOrders(true, updatedFilters);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     const newRowsPerPage = parseInt(event.target.value, 10);
//     setRowsPerPage(newRowsPerPage);
//     setPage(0);
//     const updatedFilters = { ...filters, limit: newRowsPerPage, page: 1 };
//     dispatch(setFilters(updatedFilters));
//     fetchOrders(true, updatedFilters);
//   };

//   const handleSort = (field) => {
//     const direction =
//       sortConfig.field === field && sortConfig.direction === "asc"
//         ? "desc"
//         : "asc";
//     setSortConfig({ field, direction });
//     const updatedFilters = { ...filters, sortBy: field, sortOrder: direction };
//     dispatch(setFilters(updatedFilters));
//     fetchOrders(true, updatedFilters);
//   };

//   const handleFilterChange = (field, value) => {
//     const updatedFilters = { ...filters, [field]: value, page: 1 };
//     dispatch(setFilters(updatedFilters));
//     fetchOrders(true, updatedFilters);
//     setPage(0);
//   };

//   const handleDateRangeApply = () => {
//     if (dateRange.startDate && dateRange.endDate) {
//       const formattedStartDate = format(dateRange.startDate, "yyyy-MM-dd");
//       const formattedEndDate = format(dateRange.endDate, "yyyy-MM-dd");
//       const updatedFilters = {
//         ...filters,
//         startDate: formattedStartDate,
//         endDate: formattedEndDate,
//         page: 1,
//       };
//       dispatch(setFilters(updatedFilters));
//       fetchOrders(true, updatedFilters);
//       setOpenDateRangeDialog(false);
//     }
//   };

//   const handleClearFilters = () => {
//     const updatedFilters = {
//       status: "",
//       orderType: "",
//       startDate: "",
//       endDate: "",
//       search: "",
//       page: 1,
//       limit: rowsPerPage,
//     };
//     dispatch(setFilters(updatedFilters));
//     fetchOrders(true, updatedFilters);
//     setPage(0);
//     setDateRange({ startDate: null, endDate: null });
//     setSearchQuery("");
//   };

//   const handleViewOrder = (order) => {
//     setSelectedOrder(order);
//     setOpenViewDialog(true);
//   };

//   const handleEditOrder = (order) => {
//     setSelectedOrder(order);
//     const deliveryFee = getOrderDeliveryCharge(order);
//     setOrderData({
//       name: order.customer?.name || "",
//       phone: order.customer?.phone || "",
//       address: order.customer?.address || "",
//       items: order.items.map((item) => ({
//         ...item,
//         selectedSize: item.selectedSize || null,
//         selectedVariant: item.selectedVariant || null,
//         selectedAddons: item.selectedAddons || [],
//         total: item.total || calculateItemTotal(item),
//       })),
//       deliveryCharge: deliveryFee,
//       totalAmount: getOrderTotal(order),
//       notes: order.notes || "",
//     });
//     setOpenEditDialog(true);
//   };

//   const handleUpdateOrder = () => {
//     const updatedData = {
//       ...orderData,
//       totalAmount: calculateTotalAmount(
//         orderData.items,
//         orderData.deliveryCharge,
//       ),
//     };

//     dispatch(
//       updateOrderDetails({
//         orderId: selectedOrder._id,
//         data: updatedData,
//       }),
//     ).then(() => {
//       setOpenEditDialog(false);
//       fetchOrders(true, filters);
//     });
//   };

//   const handleDeleteClick = (order) => {
//     setSelectedOrder(order);
//     setOpenDeleteDialog(true);
//   };

//   const handleConfirmDelete = () => {
//     dispatch(cancelOrder(selectedOrder._id)).then(() => {
//       setOpenDeleteDialog(false);
//       fetchOrders(true, filters);
//     });
//   };

//   const handleStatusClick = (order) => {
//     setSelectedOrder(order);
//     setNewStatus(order.status);
//     setOpenStatusDialog(true);
//   };

//   const handleStatusUpdate = () => {
//     dispatch(
//       changeOrderStatus({
//         orderId: selectedOrder._id,
//         status: newStatus,
//       }),
//     ).then(() => {
//       setOpenStatusDialog(false);
//       fetchOrders(true, filters);
//     });
//   };

//   const handlePaymentStatusMenu = (event, order) => {
//     setAnchorEl(event.currentTarget);
//     setSelectedOrder(order);
//     const payment = getOrderPayment(order._id);
//     setSelectedPayment(payment);
//   };

//   // ⭐ Context Menu Status Change Handler
//   const handlePaymentStatusChange = async (status) => {
//     try {
//       if (status === "REFUNDED" && selectedOrder) {
//         const res = await axiosInstance.put(
//           `/api/orders/${selectedOrder._id}/settle-refund`,
//         );
//         if (res.data.success) {
//           fetchOrders(false, filters);
//           dispatch(fetchOrderStats());
//         }
//       } else if (selectedPayment) {
//         await dispatch(
//           updatePaymentStatus({
//             id: selectedPayment._id,
//             statusData: { status },
//           }),
//         );
//         dispatch(getPayments({ page: 1, limit: 100 }));
//         fetchOrders(false, filters);
//       } else if (selectedOrder) {
//         setNewPaymentStatus(status);
//         setOpenPaymentStatusDialog(true);
//       }
//     } catch (err) {
//       console.error("Status update error:", err);
//     } finally {
//       setAnchorEl(null);
//     }
//   };

//   // ⭐ Modal Update Handler
//   const handlePaymentStatusDialogUpdate = async () => {
//     try {
//       if (newPaymentStatus === "REFUNDED" && selectedOrder) {
//         const res = await axiosInstance.put(
//           `/api/orders/${selectedOrder._id}/settle-refund`,
//         );
//         if (res.data.success) {
//           fetchOrders(false, filters);
//           dispatch(fetchOrderStats());
//         }
//       } else if (selectedOrder) {
//         await axiosInstance.put(`/api/orders/${selectedOrder._id}`, {
//           paymentStatus: newPaymentStatus,
//         });
//         fetchOrders(false, filters);
//       }
//     } catch (err) {
//       console.error("Payment status update error:", err);
//     } finally {
//       setOpenPaymentStatusDialog(false);
//     }
//   };

//   const handleCloseSnackbar = () => {
//     dispatch(clearError());
//     dispatch(clearSuccess());
//   };

//   const handleClosePaymentMenu = () => {
//     setAnchorEl(null);
//     setSelectedPayment(null);
//   };

//   useEffect(() => {
//     const initialFetch = async () => {
//       await dispatch(fetchAllOrders(filters));
//       await dispatch(getPayments({ page: 1, limit: 100 }));
//       await dispatch(fetchOrderStats());
//     };
//     initialFetch();
//   }, []);

//   useEffect(() => {
//     if (success) {
//       const timer = setTimeout(() => dispatch(clearSuccess()), 3000);
//       return () => clearTimeout(timer);
//     }
//     if (error) {
//       const timer = setTimeout(() => dispatch(clearError()), 5000);
//       return () => clearTimeout(timer);
//     }
//   }, [success, error, dispatch]);

//   useEffect(() => {
//     if (!socket) return;
//     socket.on("new-order", (data) => {
//       setNotification({
//         message: `🆕 New order from ${data.order.customer?.name || "Customer"}!`,
//         severity: "success",
//         order: data.order,
//       });
//       playNotificationSound();
//       showBrowserNotification(data.order);
//       fetchOrders(true);
//     });

//     socket.on("order-status-updated", (data) => {
//       fetchOrders(true);
//       setNotification({
//         message: `Order #${data.order._id?.slice(-6)} status: ${data.order.status}`,
//         severity: "info",
//         order: data.order,
//       });
//     });

//     socket.on("order-cancelled", (data) => {
//       fetchOrders(true);
//       setNotification({
//         message: `Order #${data.orderId?.slice(-6)} has been cancelled`,
//         severity: "error",
//         order: data.order,
//       });
//     });

//     socket.on("order-updated", () => {
//       fetchOrders(true);
//     });

//     return () => {
//       socket.off("new-order");
//       socket.off("order-status-updated");
//       socket.off("order-cancelled");
//       socket.off("order-updated");
//     };
//   }, [socket]);

//   const playNotificationSound = () => {
//     try {
//       const audio = new Audio("/sounds/notification.mp3");
//       audio.volume = 0.5;
//       audio.play().catch(() => {});
//     } catch (e) {}
//   };

//   const showBrowserNotification = (order) => {
//     if (window.Notification && Notification.permission === "granted") {
//       const customerName = order.customer?.name || "Customer";
//       const totalAmount =
//         order.orderSummary?.totalAmount || order.totalAmount || 0;
//       new Notification(`New Order from ${customerName}!`, {
//         body: `Amount: ₹${totalAmount} | Order Type: ${order.orderType}`,
//         icon: "🍽️",
//         tag: `order-${order._id}`,
//         requireInteraction: true,
//       });
//     }
//   };

//   useEffect(() => {
//     if (window.Notification && Notification.permission === "default") {
//       Notification.requestPermission();
//     }
//   }, []);

//   useEffect(() => {
//     if (notification) {
//       const timer = setTimeout(() => setNotification(null), 5000);
//       return () => clearTimeout(timer);
//     }
//   }, [notification]);

//   if (loading && !orders.length) {
//     return (
//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         minHeight="400px"
//       >
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <Box sx={{ width: "100%" }}>
//         <Box sx={{ mb: 4 }}>
//           <Box
//             display="flex"
//             justifyContent="space-between"
//             alignItems="center"
//             flexWrap="wrap"
//             gap={2}
//           >
//             <Box>
//               <Typography
//                 variant="h4"
//                 component="h1"
//                 sx={{ fontWeight: 700, color: "#1a365d", mb: 1 }}
//               >
//                 Orders Management
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Track, manage and update all customer orders
//               </Typography>
//             </Box>
//             <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
//               <Button
//                 variant="contained"
//                 startIcon={
//                   loading ? (
//                     <CircularProgress size={20} color="inherit" />
//                   ) : (
//                     <RefreshIcon />
//                   )
//                 }
//                 onClick={handleManualRefresh}
//                 disabled={loading}
//                 sx={{ borderRadius: 2, px: 3 }}
//               >
//                 Refresh
//               </Button>
//             </Box>
//           </Box>
//         </Box>

//         {/* Search & Filter Bar */}
//         <Box
//           sx={{
//             mb: 3,
//             display: "flex",
//             alignItems: "center",
//             gap: 2,
//             flexWrap: "wrap",
//           }}
//         >
//           <Box sx={{ flex: 1, minWidth: { xs: "100%", sm: 250 } }}>
//             {searchOpen ? (
//               <TextField
//                 fullWidth
//                 size="small"
//                 placeholder="Search by ID, customer, phone, item..."
//                 value={searchQuery}
//                 onChange={handleSearch}
//                 autoFocus
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <SearchIcon fontSize="small" />
//                     </InputAdornment>
//                   ),
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton size="small" onClick={handleSearchToggle}>
//                         <CancelIcon fontSize="small" />
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{ borderRadius: 2 }}
//               />
//             ) : (
//               <Button
//                 variant="outlined"
//                 startIcon={<SearchIcon />}
//                 onClick={handleSearchToggle}
//                 sx={{ borderRadius: 2, textTransform: "none" }}
//               >
//                 Search Orders
//               </Button>
//             )}
//           </Box>

//           <FormControl size="small" sx={{ minWidth: 130 }}>
//             <InputLabel>Status</InputLabel>
//             <Select
//               value={filters.status || ""}
//               label="Status"
//               onChange={(e) => handleFilterChange("status", e.target.value)}
//             >
//               <MenuItem value="">All</MenuItem>
//               {statusOptions.map((opt) => (
//                 <MenuItem key={opt.value} value={opt.value}>
//                   {opt.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <FormControl size="small" sx={{ minWidth: 130 }}>
//             <InputLabel>Order Type</InputLabel>
//             <Select
//               value={filters.orderType || ""}
//               label="Order Type"
//               onChange={(e) => handleFilterChange("orderType", e.target.value)}
//             >
//               <MenuItem value="">All</MenuItem>
//               {orderTypeOptions.map((opt) => (
//                 <MenuItem key={opt.value} value={opt.value}>
//                   {opt.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <Button
//             variant="outlined"
//             startIcon={<DateRangeIcon />}
//             onClick={() => setOpenDateRangeDialog(true)}
//             sx={{ borderRadius: 2, textTransform: "none" }}
//           >
//             {dateRange.startDate && dateRange.endDate
//               ? `${format(dateRange.startDate, "dd/MM")} - ${format(dateRange.endDate, "dd/MM")}`
//               : "Date Range"}
//           </Button>

//           {(filters.status ||
//             filters.orderType ||
//             filters.startDate ||
//             filters.endDate ||
//             searchQuery) && (
//             <Button
//               size="small"
//               color="error"
//               onClick={handleClearFilters}
//               sx={{ borderRadius: 2, textTransform: "none" }}
//             >
//               Clear Filters
//             </Button>
//           )}
//         </Box>

//         {/* Table Paper */}
//         <Paper
//           elevation={0}
//           sx={{
//             borderRadius: 3,
//             border: "1px solid",
//             borderColor: "divider",
//             overflow: "hidden",
//           }}
//         >
//           <TableContainer>
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ backgroundColor: "action.hover" }}>
//                   <TableCell sx={{ fontWeight: 700 }}>#</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Order ID</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Table</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Items</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Customer</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Amount</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Discount</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Order Status</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Payment Method</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Payment Status</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>
//                     <TableSortLabel
//                       active={sortConfig.field === "createdAt"}
//                       direction={
//                         sortConfig.field === "createdAt"
//                           ? sortConfig.direction
//                           : "asc"
//                       }
//                       onClick={() => handleSort("createdAt")}
//                     >
//                       Date
//                     </TableSortLabel>
//                   </TableCell>
//                   <TableCell align="center" sx={{ fontWeight: 700 }}>
//                     Actions
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {displayedOrders?.map((order, index) => {
//                   const totalAmount = getOrderTotal(order);
//                   const discountAmount = getOrderDiscount(order);
//                   const subtotal = getOrderSubtotal(order);
//                   const payment = getOrderPayment(order._id);

//                   return (
//                     <TableRow
//                       key={order?._id}
//                       hover
//                       sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
//                     >
//                       <TableCell>
//                         <Typography variant="body2" fontWeight={500}>
//                           #{page * rowsPerPage + index + 1}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Chip
//                           label={order._id?.slice(-8).toUpperCase()}
//                           size="small"
//                           sx={{
//                             fontFamily: "monospace",
//                             fontSize: "0.7rem",
//                             bgcolor: "#f5f5f5",
//                             fontWeight: 600,
//                           }}
//                         />
//                       </TableCell>
//                       <TableCell>
//                         {order.tableNumber ? (
//                           <Chip
//                             label={`Table ${order.tableNumber}`}
//                             size="small"
//                             color="primary"
//                             variant="outlined"
//                             sx={{ fontWeight: 600 }}
//                           />
//                         ) : (
//                           "-"
//                         )}
//                       </TableCell>
//                       <TableCell>
//                         <Box>
//                           <Typography
//                             variant="body2"
//                             fontWeight="600"
//                             color="primary.main"
//                           >
//                             {calculateTotalItems(order.items)}{" "}
//                             {calculateTotalItems(order.items) === 1
//                               ? "item"
//                               : "items"}
//                           </Typography>
//                           <Typography
//                             variant="caption"
//                             color="text.secondary"
//                             sx={{ display: "block" }}
//                           >
//                             {order.items?.[0]?.itemName}
//                             {order.items?.length > 1 &&
//                               ` +${order.items.length - 1} more`}
//                           </Typography>
//                         </Box>
//                       </TableCell>
//                       <TableCell>
//                         {getOrderTypeChip(order?.orderType)}
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant="body2" fontWeight={500}>
//                           {order.customer?.name || "-"}
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary">
//                           {order.customer?.phone || "-"}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Box>
//                           {discountAmount > 0 ? (
//                             <>
//                               <Typography
//                                 variant="body2"
//                                 sx={{
//                                   textDecoration: "line-through",
//                                   color: "#999",
//                                 }}
//                               >
//                                 {formatCurrency(subtotal)}
//                               </Typography>
//                               <Typography
//                                 variant="body1"
//                                 fontWeight="700"
//                                 color="success.main"
//                               >
//                                 {formatCurrency(totalAmount)}
//                               </Typography>
//                             </>
//                           ) : (
//                             <Typography
//                               variant="body1"
//                               fontWeight="700"
//                               color="primary.main"
//                             >
//                               {formatCurrency(totalAmount)}
//                             </Typography>
//                           )}
//                         </Box>

//                         {/* ⭐ Table me Refund Alert Chip */}
//                         {Number(order.orderSummary?.refundDue || 0) > 0 && (
//                           <Chip
//                             label={`Refund Due: ₹${Number(order.orderSummary.refundDue).toFixed(2)}`}
//                             size="small"
//                             sx={{
//                               mt: 0.5,
//                               height: 18,
//                               fontSize: "0.6rem",
//                               fontWeight: 800,
//                               bgcolor: "#ffebee",
//                               color: "#c62828",
//                               border: "1px solid #ffcdd2",
//                             }}
//                           />
//                         )}
//                       </TableCell>

//                       <TableCell>
//                         {discountAmount > 0 ? (
//                           <Chip
//                             label={`-${formatCurrency(discountAmount)}`}
//                             size="small"
//                             color="success"
//                             icon={<OfferIcon sx={{ fontSize: "0.8rem" }} />}
//                             sx={{ fontWeight: 600 }}
//                           />
//                         ) : (
//                           <Typography variant="caption" color="text.secondary">
//                             —
//                           </Typography>
//                         )}
//                       </TableCell>
//                       <TableCell>
//                         <Box
//                           onClick={() => handleStatusClick(order)}
//                           sx={{ cursor: "pointer" }}
//                         >
//                           {getStatusChip(order.status)}
//                         </Box>
//                       </TableCell>
//                       <TableCell>
//                         {payment?.method || order.paymentMethod ? (
//                           getPaymentMethodChip(payment?.method || order.paymentMethod)
//                         ) : (
//                           <Typography variant="caption" color="text.secondary">
//                             —
//                           </Typography>
//                         )}
//                       </TableCell>
//                       <TableCell>
//                         <Box
//                           onClick={(e) => handlePaymentStatusMenu(e, order)}
//                           sx={{ cursor: "pointer" }}
//                         >
//                           {getPaymentStatusChip(
//                             payment?.status || order.paymentStatus || "PENDING",
//                           )}
//                         </Box>
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant="caption" fontWeight={500}>
//                           {formatDate(order.createdAt)}
//                         </Typography>
//                       </TableCell>
//                       <TableCell align="center">
//                         <Stack
//                           direction="row"
//                           spacing={1}
//                           justifyContent="center"
//                         >
//                           <Tooltip title="View Details">
//                             <IconButton
//                               size="small"
//                               color="primary"
//                               onClick={() => handleViewOrder(order)}
//                               sx={{
//                                 bgcolor: "primary.light",
//                                 color: "white",
//                                 "&:hover": { bgcolor: "primary.main" },
//                               }}
//                             >
//                               <ViewIcon fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                           <Tooltip title="Edit Order">
//                             <IconButton
//                               size="small"
//                               color="secondary"
//                               onClick={() => handleEditOrder(order)}
//                               disabled={
//                                 order.status === "CANCELLED" ||
//                                 order.status === "DELIVERED"
//                               }
//                               sx={{
//                                 bgcolor: "secondary.light",
//                                 color: "white",
//                                 "&:hover": { bgcolor: "secondary.main" },
//                               }}
//                             >
//                               <EditIcon fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                           <Tooltip title="Cancel Order">
//                             <IconButton
//                               size="small"
//                               color="error"
//                               onClick={() => handleDeleteClick(order)}
//                               disabled={
//                                 order.status === "CANCELLED" ||
//                                 order.status === "DELIVERED"
//                               }
//                               sx={{
//                                 bgcolor: "error.light",
//                                 color: "white",
//                                 "&:hover": { bgcolor: "error.main" },
//                               }}
//                             >
//                               <DeleteIcon fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                         </Stack>
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })}
//               </TableBody>
//             </Table>
//           </TableContainer>
//           {orders?.length === 0 && !loading && (
//             <Box sx={{ p: 8, textAlign: "center" }}>
//               <CartIcon sx={{ fontSize: 60, color: "#e0e0e0", mb: 2 }} />
//               <Typography variant="h6" color="text.secondary" gutterBottom>
//                 No orders found
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Try changing your filters or create a new order
//               </Typography>
//             </Box>
//           )}
//           <TablePagination
//             rowsPerPageOptions={[5, 10, 25, 50]}
//             component="div"
//             count={totalOrders}
//             rowsPerPage={rowsPerPage}
//             page={page}
//             onPageChange={handleChangePage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//             sx={{ borderTop: "1px solid", borderColor: "divider" }}
//           />
//         </Paper>

//         {/* ⭐ Payment Menu (All Options with Icons) */}
//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={handleClosePaymentMenu}
//         >
//           <MenuItem onClick={() => handlePaymentStatusChange("PAID")}>
//             <CheckCircleIcon
//               sx={{ mr: 1, color: "success.main" }}
//               fontSize="small"
//             />
//             Mark as Paid
//           </MenuItem>
//           <MenuItem onClick={() => handlePaymentStatusChange("PENDING")}>
//             <PendingIcon
//               sx={{ mr: 1, color: "warning.main" }}
//               fontSize="small"
//             />
//             Mark as Pending
//           </MenuItem>
//           <MenuItem onClick={() => handlePaymentStatusChange("REFUND_PENDING")}>
//             <RefundIcon
//               sx={{ mr: 1, color: "error.main" }}
//               fontSize="small"
//             />
//             Mark as Refund Pending
//           </MenuItem>
//           <MenuItem onClick={() => handlePaymentStatusChange("REFUNDED")}>
//             <PaymentIcon sx={{ mr: 1, color: "info.main" }} fontSize="small" />
//             Mark as Refunded
//           </MenuItem>
//           <MenuItem onClick={() => handlePaymentStatusChange("FAILED")}>
//             <CancelIcon sx={{ mr: 1, color: "error.main" }} fontSize="small" />
//             Mark as Failed
//           </MenuItem>
//         </Menu>

//         {/* View Order Dialog */}
//         <Dialog
//           open={openViewDialog}
//           onClose={() => setOpenViewDialog(false)}
//           maxWidth="md"
//           fullWidth
//         >
//           <DialogTitle
//             sx={{ borderBottom: "1px solid", borderColor: "divider", pb: 2 }}
//           >
//             <Box display="flex" alignItems="center" gap={2}>
//               <Avatar sx={{ bgcolor: "primary.main" }}>
//                 <CartIcon />
//               </Avatar>
//               <Box>
//                 <Typography variant="h6" sx={{ fontWeight: 700 }}>
//                   Order Details
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   Order ID: {selectedOrder?._id}
//                 </Typography>
//               </Box>
//             </Box>
//           </DialogTitle>
//           <DialogContent dividers sx={{ p: 3 }}>
//             {selectedOrder && (
//               <>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: { xs: "column", md: "row" },
//                     gap: 3,
//                     mb: 4,
//                   }}
//                 >
//                   <Box
//                     sx={{ flex: 1, p: 2, bgcolor: "#f8fafc", borderRadius: 2 }}
//                   >
//                     <Typography
//                       variant="subtitle1"
//                       fontWeight="700"
//                       gutterBottom
//                       sx={{ display: "flex", alignItems: "center", gap: 1 }}
//                     >
//                       <Avatar
//                         sx={{ width: 24, height: 24, bgcolor: "primary.light" }}
//                       >
//                         👤
//                       </Avatar>
//                       Customer Information
//                     </Typography>
//                     <Divider sx={{ mb: 2 }} />
//                     <Grid container spacing={1.5}>
//                       <Grid size={{ xs: 4 }}>
//                         <Typography variant="body2" color="text.secondary">
//                           Name:
//                         </Typography>
//                       </Grid>
//                       <Grid size={{ xs: 8 }}>
//                         <Typography variant="body2" fontWeight="600">
//                           {selectedOrder.customer?.name || "-"}
//                         </Typography>
//                       </Grid>
//                       <Grid size={{ xs: 4 }}>
//                         <Typography variant="body2" color="text.secondary">
//                           Phone:
//                         </Typography>
//                       </Grid>
//                       <Grid size={{ xs: 8 }}>
//                         <Typography variant="body2" fontWeight="600">
//                           {selectedOrder.customer?.phone || "-"}
//                         </Typography>
//                       </Grid>
//                       {selectedOrder.customer?.address && (
//                         <>
//                           <Grid size={{ xs: 4 }}>
//                             <Typography variant="body2" color="text.secondary">
//                               Address:
//                             </Typography>
//                           </Grid>
//                           <Grid size={{ xs: 8 }}>
//                             <Typography variant="body2">
//                               {selectedOrder.customer.address}
//                             </Typography>
//                           </Grid>
//                         </>
//                       )}
//                     </Grid>
//                   </Box>

//                   <Box
//                     sx={{ flex: 1, p: 2, bgcolor: "#f8fafc", borderRadius: 2 }}
//                   >
//                     <Typography
//                       variant="subtitle1"
//                       fontWeight="700"
//                       gutterBottom
//                       sx={{ display: "flex", alignItems: "center", gap: 1 }}
//                     >
//                       <Avatar
//                         sx={{ width: 24, height: 24, bgcolor: "info.light" }}
//                       >
//                         📦
//                       </Avatar>
//                       Order Information
//                     </Typography>
//                     <Divider sx={{ mb: 2 }} />
//                     <Grid container spacing={1.5}>
//                       <Grid size={{ xs: 4 }}>
//                         <Typography variant="body2" color="text.secondary">
//                           Order Type:
//                         </Typography>
//                       </Grid>
//                       <Grid size={{ xs: 8 }}>
//                         {getOrderTypeChip(selectedOrder.orderType)}
//                       </Grid>
//                       {selectedOrder.tableNumber && (
//                         <>
//                           <Grid size={{ xs: 4 }}>
//                             <Typography variant="body2" color="text.secondary">
//                               Table:
//                             </Typography>
//                           </Grid>
//                           <Grid size={{ xs: 8 }}>
//                             <Chip
//                               label={`Table ${selectedOrder.tableNumber}`}
//                               size="small"
//                               color="primary"
//                               variant="outlined"
//                             />
//                           </Grid>
//                         </>
//                       )}
//                       <Grid size={{ xs: 4 }}>
//                         <Typography variant="body2" color="text.secondary">
//                           Order Status:
//                         </Typography>
//                       </Grid>
//                       <Grid size={{ xs: 8 }}>
//                         {getStatusChip(selectedOrder.status)}
//                       </Grid>
//                       <Grid size={{ xs: 4 }}>
//                         <Typography variant="body2" color="text.secondary">
//                           Order Date:
//                         </Typography>
//                       </Grid>
//                       <Grid size={{ xs: 8 }}>
//                         <Typography variant="body2">
//                           {formatDate(selectedOrder.createdAt)}
//                         </Typography>
//                       </Grid>
//                     </Grid>
//                   </Box>
//                 </Box>

//                 <Box sx={{ mb: 3 }}>
//                   <Typography
//                     variant="subtitle1"
//                     fontWeight="700"
//                     gutterBottom
//                     sx={{ display: "flex", alignItems: "center", gap: 1 }}
//                   >
//                     <Avatar
//                       sx={{ width: 24, height: 24, bgcolor: "success.light" }}
//                     >
//                       💰
//                     </Avatar>
//                     Payment Information
//                   </Typography>
//                   <Divider sx={{ mb: 2 }} />
//                   <Paper sx={{ p: 2, bgcolor: "#f8fafc", borderRadius: 2 }}>
//                     <Grid container spacing={2}>
//                       <Grid size={{ xs: 6, md: 3 }}>
//                         <Typography variant="body2" color="text.secondary">
//                           Payment Method:
//                         </Typography>
//                         <Typography variant="body1" fontWeight="600">
//                           {getOrderPayment(selectedOrder._id)?.method ||
//                             selectedOrder.paymentMethod ||
//                             "Not Set"}
//                         </Typography>
//                       </Grid>
//                       <Grid size={{ xs: 6, md: 3 }}>
//                         <Typography variant="body2" color="text.secondary">
//                           Payment Status:
//                         </Typography>
//                         <Box sx={{ mt: 0.5 }}>
//                           {getPaymentStatusChip(
//                             getOrderPayment(selectedOrder._id)?.status ||
//                               selectedOrder.paymentStatus ||
//                               "PENDING",
//                           )}
//                         </Box>
//                       </Grid>
//                       <Grid size={{ xs: 6, md: 3 }}>
//                         <Typography variant="body2" color="text.secondary">
//                           Paid Amount:
//                         </Typography>
//                         <Typography
//                           variant="body1"
//                           fontWeight="700"
//                           color="success.main"
//                         >
//                           {formatCurrency(
//                             getOrderPayment(selectedOrder._id)?.amount ||
//                               selectedOrder.orderSummary?.paidAmount ||
//                               getOrderTotal(selectedOrder),
//                           )}
//                         </Typography>
//                       </Grid>
//                     </Grid>
//                   </Paper>
//                 </Box>

//                 {/* Applied Offers */}
//                 {selectedOrder.appliedOffers &&
//                   selectedOrder.appliedOffers.length > 0 && (
//                     <Box sx={{ mb: 3 }}>
//                       <Typography
//                         variant="subtitle1"
//                         fontWeight="700"
//                         gutterBottom
//                         sx={{ display: "flex", alignItems: "center", gap: 1 }}
//                       >
//                         <Avatar
//                           sx={{
//                             width: 24,
//                             height: 24,
//                             bgcolor: "success.light",
//                           }}
//                         >
//                           🏷️
//                         </Avatar>
//                         Applied Offers
//                       </Typography>
//                       <Divider sx={{ mb: 2 }} />
//                       <Grid container spacing={1.5}>
//                         {selectedOrder.appliedOffers.map((offer, idx) => (
//                           <Grid size={{ xs: 12 }} key={idx}>
//                             <Paper
//                               sx={{
//                                 p: 1.5,
//                                 bgcolor: "#e8f5e9",
//                                 borderRadius: 2,
//                                 display: "flex",
//                                 justifyContent: "space-between",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <Box display="flex" alignItems="center" gap={1.5}>
//                                 <OfferIcon
//                                   sx={{ color: "#2e7d32", fontSize: 20 }}
//                                 />
//                                 <Box>
//                                   <Typography
//                                     variant="body2"
//                                     fontWeight="700"
//                                     sx={{ color: "#2e7d32" }}
//                                   >
//                                     {offer.offerCode}
//                                   </Typography>
//                                   <Typography
//                                     variant="caption"
//                                     color="text.secondary"
//                                   >
//                                     {offer.offerTitle || offer.description}
//                                   </Typography>
//                                 </Box>
//                               </Box>
//                               <Chip
//                                 label={`-${formatCurrency(offer.discountAmount)}`}
//                                 size="small"
//                                 color="success"
//                                 sx={{ fontWeight: 700 }}
//                               />
//                             </Paper>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     </Box>
//                   )}

//                 {/* Items */}
//                 <Box sx={{ mb: 3 }}>
//                   <Typography
//                     variant="subtitle1"
//                     fontWeight="700"
//                     gutterBottom
//                     sx={{ display: "flex", alignItems: "center", gap: 1 }}
//                   >
//                     <Avatar
//                       sx={{ width: 24, height: 24, bgcolor: "warning.light" }}
//                     >
//                       🍽️
//                     </Avatar>
//                     Order Items
//                   </Typography>
//                   <Divider sx={{ mb: 2 }} />
//                   <TableContainer
//                     component={Paper}
//                     variant="outlined"
//                     sx={{ borderRadius: 2 }}
//                   >
//                     <Table size="small">
//                       <TableHead sx={{ bgcolor: "#f5f5f5" }}>
//                         <TableRow>
//                           <TableCell sx={{ fontWeight: 700 }}>#</TableCell>
//                           <TableCell sx={{ fontWeight: 700 }}>Item</TableCell>
//                           <TableCell align="right" sx={{ fontWeight: 700 }}>
//                             Qty
//                           </TableCell>
//                           <TableCell align="right" sx={{ fontWeight: 700 }}>
//                             Price
//                           </TableCell>
//                           <TableCell align="right" sx={{ fontWeight: 700 }}>
//                             Total
//                           </TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {selectedOrder.items.map((item, index) => {
//                           const itemTotal =
//                             item.total || calculateItemTotal(item);
//                           return (
//                             <TableRow key={index} hover>
//                               <TableCell>#{index + 1}</TableCell>
//                               <TableCell>
//                                 <Box
//                                   display="flex"
//                                   alignItems="center"
//                                   gap={1.5}
//                                 >
//                                   <Avatar
//                                     src={item.itemId?.image}
//                                     sx={{
//                                       width: 40,
//                                       height: 40,
//                                       borderRadius: 1.5,
//                                     }}
//                                     variant="rounded"
//                                   >
//                                     {item.itemName?.charAt(0)}
//                                   </Avatar>
//                                   <Box>
//                                     <Typography
//                                       variant="body2"
//                                       fontWeight="600"
//                                     >
//                                       {item.itemName}
//                                     </Typography>
//                                     {item.selectedSize?.name && (
//                                       <Typography
//                                         variant="caption"
//                                         display="block"
//                                         color="primary.main"
//                                         sx={{ fontSize: "0.7rem" }}
//                                       >
//                                         Size: {item.selectedSize.name} (₹
//                                         {item.selectedSize.price})
//                                       </Typography>
//                                     )}
//                                     {item.selectedVariant?.name && (
//                                       <Typography
//                                         variant="caption"
//                                         display="block"
//                                         color="secondary.main"
//                                         sx={{ fontSize: "0.7rem" }}
//                                       >
//                                         Variant: {item.selectedVariant.name} (+₹
//                                         {item.selectedVariant.price})
//                                       </Typography>
//                                     )}
//                                   </Box>
//                                 </Box>
//                               </TableCell>
//                               <TableCell align="right">
//                                 <Chip
//                                   label={item.quantity}
//                                   size="small"
//                                   sx={{ fontWeight: 700, minWidth: 35 }}
//                                 />
//                               </TableCell>
//                               <TableCell align="right">
//                                 {item.appliedOffer?.discountAmount > 0 ? (
//                                   <Box sx={{ textAlign: "right" }}>
//                                     <Typography
//                                       variant="caption"
//                                       sx={{
//                                         display: "block",
//                                         textDecoration: "line-through",
//                                         color: "#999",
//                                         fontSize: "0.7rem",
//                                       }}
//                                     >
//                                       ₹{item.originalPrice || item.price || 0}
//                                     </Typography>
//                                     <Typography
//                                       variant="body2"
//                                       fontWeight="700"
//                                       color="success.main"
//                                     >
//                                       ₹{item.price || 0}
//                                     </Typography>
//                                   </Box>
//                                 ) : (
//                                   <Typography variant="body2">
//                                     ₹
//                                     {item.price ||
//                                       item.selectedSize?.price ||
//                                       0}
//                                   </Typography>
//                                 )}
//                               </TableCell>
//                               <TableCell align="right">
//                                 {item.appliedOffer?.discountAmount > 0 ? (
//                                   <Box sx={{ textAlign: "right" }}>
//                                     <Typography
//                                       variant="caption"
//                                       sx={{
//                                         display: "block",
//                                         textDecoration: "line-through",
//                                         color: "#999",
//                                         fontSize: "0.7rem",
//                                       }}
//                                     >
//                                       ₹
//                                       {(
//                                         (item.originalPrice ||
//                                           item.price ||
//                                           0) * item.quantity
//                                       ).toFixed(2)}
//                                     </Typography>
//                                     <Typography
//                                       variant="body2"
//                                       fontWeight="700"
//                                       color="success.main"
//                                     >
//                                       ₹{itemTotal.toFixed(2)}
//                                     </Typography>
//                                   </Box>
//                                 ) : (
//                                   <Typography
//                                     variant="body2"
//                                     fontWeight="700"
//                                     color="primary.main"
//                                   >
//                                     ₹{itemTotal.toFixed(2)}
//                                   </Typography>
//                                 )}
//                               </TableCell>
//                             </TableRow>
//                           );
//                         })}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                 </Box>

//                 {/* Free items */}
//                 {selectedOrder.freeItems &&
//                   selectedOrder.freeItems.length > 0 && (
//                     <Box sx={{ mb: 3 }}>
//                       <Typography
//                         variant="subtitle1"
//                         fontWeight="700"
//                         gutterBottom
//                         sx={{ display: "flex", alignItems: "center", gap: 1 }}
//                       >
//                         <Avatar
//                           sx={{
//                             width: 24,
//                             height: 24,
//                             bgcolor: "success.light",
//                           }}
//                         >
//                           🎁
//                         </Avatar>
//                         Free Items
//                       </Typography>
//                       <Divider sx={{ mb: 2 }} />
//                       <Grid container spacing={1.5}>
//                         {selectedOrder.freeItems.map((item, idx) => (
//                           <Grid size={{ xs: 12, sm: 6 }} key={idx}>
//                             <Paper
//                               sx={{
//                                 p: 1.5,
//                                 bgcolor: "#e8f5e9",
//                                 borderRadius: 2,
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: 1.5,
//                               }}
//                             >
//                               <Avatar
//                                 src={item.itemId?.image}
//                                 sx={{
//                                   width: 40,
//                                   height: 40,
//                                   borderRadius: 1.5,
//                                 }}
//                               />
//                               <Box>
//                                 <Typography variant="body2" fontWeight="600">
//                                   {item.itemName} × {item.quantity}
//                                 </Typography>
//                                 <Typography
//                                   variant="caption"
//                                   color="success.main"
//                                   fontWeight="700"
//                                 >
//                                   FREE (₹{item.price} saved)
//                                 </Typography>
//                               </Box>
//                             </Paper>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     </Box>
//                   )}

//                 {/* Payment Summary */}
//                 <Box sx={{ mt: 3 }}>
//                   <Typography
//                     variant="subtitle1"
//                     fontWeight="700"
//                     gutterBottom
//                     sx={{ display: "flex", alignItems: "center", gap: 1 }}
//                   >
//                     <Avatar sx={{ width: 24, height: 24, bgcolor: "info.light" }}>
//                       💰
//                     </Avatar>
//                     Payment Summary
//                   </Typography>
//                   <Divider sx={{ mb: 2 }} />
//                   <Paper sx={{ p: 2, bgcolor: "#f8fafc", borderRadius: 2 }}>
//                     <Grid container spacing={1.5}>
//                       <Grid size={{ xs: 6 }}>
//                         <Typography variant="body2" color="text.secondary">
//                           Subtotal:
//                         </Typography>
//                       </Grid>
//                       <Grid size={{ xs: 6 }}>
//                         <Typography
//                           variant="body2"
//                           align="right"
//                           fontWeight="500"
//                         >
//                           {formatCurrency(getOrderSubtotal(selectedOrder))}
//                         </Typography>
//                       </Grid>

//                       {/* Total Discount */}
//                       {selectedOrder.orderSummary?.totalDiscount > 0 && (
//                         <>
//                           <Grid size={{ xs: 6 }}>
//                             <Typography variant="body2" color="success.main">
//                               Total Discount:
//                             </Typography>
//                           </Grid>
//                           <Grid size={{ xs: 6 }}>
//                             <Typography
//                               variant="body2"
//                               align="right"
//                               fontWeight="700"
//                               color="success.main"
//                             >
//                               -
//                               {formatCurrency(
//                                 selectedOrder.orderSummary.totalDiscount,
//                               )}
//                             </Typography>
//                           </Grid>
//                         </>
//                       )}

//                       {/* Delivery Charge */}
//                       {selectedOrder.orderType === "DELIVERY" && (
//                         <>
//                           <Grid size={{ xs: 6 }}>
//                             <Typography variant="body2" color="text.secondary">
//                               Delivery Charge:
//                             </Typography>
//                           </Grid>
//                           <Grid size={{ xs: 6 }}>
//                             <Typography
//                               variant="body2"
//                               align="right"
//                               fontWeight="600"
//                               color={
//                                 getOrderDeliveryCharge(selectedOrder) === 0
//                                   ? "success.main"
//                                   : "text.primary"
//                               }
//                             >
//                               {getOrderDeliveryCharge(selectedOrder) === 0
//                                 ? "FREE"
//                                 : formatCurrency(
//                                     getOrderDeliveryCharge(selectedOrder),
//                                   )}
//                             </Typography>
//                           </Grid>
//                         </>
//                       )}

//                       <Grid size={{ xs: 12 }}>
//                         <Divider sx={{ my: 0.5 }} />
//                       </Grid>

//                       <Grid size={{ xs: 6 }}>
//                         <Typography variant="h6" fontWeight="700">
//                           Total:
//                         </Typography>
//                       </Grid>
//                       <Grid size={{ xs: 6 }}>
//                         <Typography
//                           variant="h6"
//                           align="right"
//                           fontWeight="700"
//                           color="primary.main"
//                         >
//                           {formatCurrency(getOrderTotal(selectedOrder))}
//                         </Typography>
//                       </Grid>

//                       {/* ⭐ View Dialog: Actionable Refund Banner for Owner */}
//                       {Number(selectedOrder.orderSummary?.refundDue || 0) > 0 && (
//                         <Grid size={{ xs: 12 }}>
//                           <Box
//                             sx={{
//                               mt: 1.5,
//                               p: 2,
//                               bgcolor: "#ffebee",
//                               borderRadius: 2,
//                               border: "1.5px solid #ef5350",
//                               display: "flex",
//                               flexDirection: { xs: "column", sm: "row" },
//                               justifyContent: "space-between",
//                               alignItems: { xs: "flex-start", sm: "center" },
//                               gap: 1.5,
//                             }}
//                           >
//                             <Box>
//                               <Typography
//                                 variant="subtitle2"
//                                 fontWeight={800}
//                                 color="#c62828"
//                               >
//                                 ⚠ Action Required: Refund ₹
//                                 {Number(
//                                   selectedOrder.orderSummary.refundDue,
//                                 ).toFixed(2)}{" "}
//                                 to Customer
//                               </Typography>
//                               <Typography
//                                 variant="caption"
//                                 color="text.secondary"
//                               >
//                                 {/* Customer ne order cancel ya items kam kiye hain.
//                                 UPI/Cash se refund bhej kar niche confirm
//                                 karein. */}
//                                 Customer reduced items or cancelled order. Please issue refund via UPI/Cash and confirm below.
//                               </Typography>
//                             </Box>

//                             <Button
//                               variant="contained"
//                               color="success"
//                               size="small"
//                               onClick={async () => {
//                                 try {
//                                   const res = await axiosInstance.put(
//                                     `/api/orders/${selectedOrder._id}/settle-refund`,
//                                   );
//                                   if (res.data.success) {
//                                     setSelectedOrder(res.data.order);
//                                     fetchOrders(false);
//                                     dispatch(fetchOrderStats());
//                                   }
//                                 } catch (err) {
//                                   console.error(
//                                     "Failed to settle refund:",
//                                     err,
//                                   );
//                                 }
//                               }}
//                               sx={{
//                                 borderRadius: 2,
//                                 fontWeight: 700,
//                                 textTransform: "none",
//                                 bgcolor: "#2e7d32",
//                                 "&:hover": { bgcolor: "#1b5e20" },
//                                 whiteSpace: "nowrap",
//                               }}
//                             >
//                               Mark as Refunded ✅
//                             </Button>
//                           </Box>
//                         </Grid>
//                       )}

//                       {selectedOrder.orderSummary?.totalDiscount > 0 && (
//                         <Grid size={{ xs: 12 }}>
//                           <Typography
//                             variant="caption"
//                             color="success.main"
//                             sx={{ display: "block", textAlign: "right" }}
//                           >
//                             🎉 Customer saved{" "}
//                             {formatCurrency(
//                               selectedOrder.orderSummary.totalDiscount,
//                             )}
//                             !
//                           </Typography>
//                         </Grid>
//                       )}
//                     </Grid>
//                   </Paper>
//                 </Box>
//               </>
//             )}
//           </DialogContent>
//           <DialogActions
//             sx={{ p: 2, borderTop: "1px solid", borderColor: "divider" }}
//           >
//             <Button
//               onClick={() => setOpenViewDialog(false)}
//               variant="contained"
//               sx={{ borderRadius: 2 }}
//             >
//               Close
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Edit Order Dialog */}
//         <Dialog
//           open={openEditDialog}
//           onClose={() => setOpenEditDialog(false)}
//           maxWidth="md"
//           fullWidth
//         >
//           <DialogTitle
//             sx={{ borderBottom: "1px solid", borderColor: "divider" }}
//           >
//             <Box display="flex" alignItems="center" gap={2}>
//               <Avatar sx={{ bgcolor: "secondary.main" }}>
//                 <EditIcon />
//               </Avatar>
//               <Box>
//                 <Typography variant="h6" sx={{ fontWeight: 700 }}>
//                   Edit Order #{selectedOrder?._id?.slice(-8).toUpperCase()}
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   Order ID: {selectedOrder?._id}
//                 </Typography>
//               </Box>
//             </Box>
//           </DialogTitle>
//           <DialogContent sx={{ pt: 3 }}>
//             <Grid container spacing={2} mt={1}>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField
//                   fullWidth
//                   label="Customer Name"
//                   value={orderData.name}
//                   onChange={(e) =>
//                     setOrderData({ ...orderData, name: e.target.value })
//                   }
//                   size="small"
//                   variant="outlined"
//                 />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField
//                   fullWidth
//                   label="Phone Number"
//                   value={orderData.phone}
//                   onChange={(e) =>
//                     setOrderData({ ...orderData, phone: e.target.value })
//                   }
//                   size="small"
//                   variant="outlined"
//                 />
//               </Grid>
//               <Grid size={{ xs: 12 }}>
//                 <TextField
//                   fullWidth
//                   label="Address"
//                   multiline
//                   rows={2}
//                   value={orderData.address}
//                   onChange={(e) =>
//                     setOrderData({ ...orderData, address: e.target.value })
//                   }
//                   size="small"
//                   variant="outlined"
//                 />
//               </Grid>

//               {/* Items editing section */}
//               <Grid size={{ xs: 12 }}>
//                 <Typography
//                   variant="subtitle1"
//                   fontWeight="700"
//                   gutterBottom
//                   sx={{ mt: 1 }}
//                 >
//                   Order Items
//                 </Typography>
//                 <Divider sx={{ mb: 2 }} />
//                 {orderData?.items && orderData.items.length > 0 ? (
//                   <Box sx={{ maxHeight: "40vh", overflow: "auto", pr: 1 }}>
//                     {orderData.items.map((item, index) => (
//                       <Paper
//                         key={item._id || index}
//                         variant="outlined"
//                         sx={{
//                           p: 2,
//                           mb: 2,
//                           borderRadius: 2,
//                           borderLeft:
//                             item.appliedOffer?.discountAmount > 0
//                               ? "4px solid #4caf50"
//                               : "1px solid #e0e0e0",
//                         }}
//                       >
//                         <Box
//                           display="flex"
//                           alignItems="center"
//                           justifyContent="space-between"
//                           mb={1.5}
//                         >
//                           <Box display="flex" alignItems="center" gap={1.5}>
//                             <Avatar
//                               src={item.itemId?.image}
//                               sx={{ width: 40, height: 40, borderRadius: 1.5 }}
//                             />
//                             <Box>
//                               <Typography variant="subtitle2" fontWeight="700">
//                                 {item.itemName}
//                               </Typography>
//                               {item.appliedOffer?.discountAmount > 0 && (
//                                 <Chip
//                                   label={`Offer: ${item.appliedOffer.offerCode}`}
//                                   size="small"
//                                   sx={{
//                                     height: 18,
//                                     fontSize: "0.6rem",
//                                     bgcolor: "#e8f5e9",
//                                     color: "#2e7d32",
//                                   }}
//                                 />
//                               )}
//                             </Box>
//                           </Box>
//                           <Typography variant="caption" color="text.secondary">
//                             ₹{item.price || item.selectedSize?.price || 0} each
//                           </Typography>
//                         </Box>

//                         {item.selectedSize?.name && (
//                           <Box
//                             sx={{
//                               mb: 1,
//                               p: 1,
//                               bgcolor: "#e3f2fd",
//                               borderRadius: 1,
//                             }}
//                           >
//                             <Typography
//                               variant="caption"
//                               fontWeight="600"
//                               color="primary.main"
//                             >
//                               Size: {item.selectedSize.name} (₹
//                               {item.selectedSize.price})
//                             </Typography>
//                           </Box>
//                         )}
//                         {item.selectedVariant?.name && (
//                           <Box
//                             sx={{
//                               mb: 1,
//                               p: 1,
//                               bgcolor: "#f3e5f5",
//                               borderRadius: 1,
//                             }}
//                           >
//                             <Typography
//                               variant="caption"
//                               fontWeight="600"
//                               color="secondary.main"
//                             >
//                               Variant: {item.selectedVariant.name} (+₹
//                               {item.selectedVariant.price})
//                             </Typography>
//                           </Box>
//                         )}
//                         {item.selectedAddons?.length > 0 && (
//                           <Box
//                             sx={{
//                               mb: 1.5,
//                               p: 1,
//                               bgcolor: "#e8f5e9",
//                               borderRadius: 1,
//                             }}
//                           >
//                             <Typography
//                               variant="caption"
//                               fontWeight="600"
//                               color="success.main"
//                               gutterBottom
//                             >
//                               Addons:
//                             </Typography>
//                             {item.selectedAddons.map((addon, i) => (
//                               <Typography
//                                 key={i}
//                                 variant="caption"
//                                 display="block"
//                                 sx={{ ml: 1 }}
//                               >
//                                 • {addon.name}: +₹{addon.price}
//                               </Typography>
//                             ))}
//                           </Box>
//                         )}

//                         <Grid container spacing={2} alignItems="center">
//                           <Grid size={{ xs: 6 }}>
//                             <TextField
//                               fullWidth
//                               size="small"
//                               label="Quantity"
//                               type="number"
//                               value={item.quantity}
//                               onChange={(e) => {
//                                 const newItems = [...orderData.items];
//                                 const quantity = parseInt(e.target.value) || 0;
//                                 newItems[index] = {
//                                   ...newItems[index],
//                                   quantity,
//                                   total: calculateItemTotal({
//                                     ...newItems[index],
//                                     quantity,
//                                   }),
//                                 };
//                                 setOrderData({
//                                   ...orderData,
//                                   items: newItems,
//                                   totalAmount: calculateTotalAmount(
//                                     newItems,
//                                     orderData.deliveryCharge,
//                                   ),
//                                 });
//                               }}
//                               InputProps={{ inputProps: { min: 0 } }}
//                             />
//                           </Grid>
//                           <Grid size={{ xs: 6 }}>
//                             <TextField
//                               fullWidth
//                               size="small"
//                               label="Price"
//                               type="number"
//                               value={
//                                 item.price || item.selectedSize?.price || 0
//                               }
//                               disabled={!!item.selectedSize?.price}
//                               InputProps={{
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     ₹
//                                   </InputAdornment>
//                                 ),
//                               }}
//                             />
//                           </Grid>
//                         </Grid>

//                         <Box display="flex" justifyContent="flex-end" mt={1.5}>
//                           <Typography
//                             variant="body2"
//                             color="primary.main"
//                             fontWeight="700"
//                           >
//                             Subtotal: ₹{item.total || calculateItemTotal(item)}
//                           </Typography>
//                           {item.appliedOffer?.discountAmount > 0 && (
//                             <Typography
//                               variant="caption"
//                               color="success.main"
//                               sx={{ ml: 1 }}
//                             >
//                               (Save ₹
//                               {Number(item.appliedOffer.discountAmount).toFixed(
//                                 2,
//                               )}
//                               )
//                             </Typography>
//                           )}
//                         </Box>
//                       </Paper>
//                     ))}
//                   </Box>
//                 ) : (
//                   <Typography
//                     color="text.secondary"
//                     align="center"
//                     sx={{ py: 4 }}
//                   >
//                     No items in this order
//                   </Typography>
//                 )}
//               </Grid>

//               {/* Delivery Charge Edit (if DELIVERY order) */}
//               {selectedOrder?.orderType === "DELIVERY" && (
//                 <Grid size={{ xs: 12, md: 6 }}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Delivery Charge"
//                     type="number"
//                     value={orderData.deliveryCharge}
//                     onChange={(e) => {
//                       const dCharge = Number(e.target.value) || 0;
//                       setOrderData({
//                         ...orderData,
//                         deliveryCharge: dCharge,
//                         totalAmount: calculateTotalAmount(
//                           orderData.items,
//                           dCharge,
//                         ),
//                       });
//                     }}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">₹</InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>
//               )}

//               {/* Total Summary Paper */}
//               <Grid size={{ xs: 12 }}>
//                 <Paper
//                   sx={{ p: 2, mt: 1, bgcolor: "#f8fafc", borderRadius: 2 }}
//                 >
//                   <Box
//                     display="flex"
//                     justifyContent="space-between"
//                     alignItems="center"
//                   >
//                     <Typography variant="h6" sx={{ fontWeight: 700 }}>
//                       Total Amount:
//                     </Typography>
//                     <Box textAlign="right">
//                       {selectedOrder?.orderSummary?.totalDiscount > 0 && (
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "#999", textDecoration: "line-through" }}
//                         >
//                           {formatCurrency(selectedOrder.orderSummary.subtotal)}
//                         </Typography>
//                       )}
//                       <Typography
//                         variant="h5"
//                         color="primary.main"
//                         fontWeight="700"
//                       >
//                         {formatCurrency(orderData.totalAmount)}
//                       </Typography>
//                       {selectedOrder?.orderSummary?.totalDiscount > 0 && (
//                         <Typography
//                           variant="caption"
//                           color="success.main"
//                           sx={{ display: "block" }}
//                         >
//                           Discount: -
//                           {formatCurrency(
//                             selectedOrder.orderSummary.totalDiscount,
//                           )}
//                         </Typography>
//                       )}
//                     </Box>
//                   </Box>
//                 </Paper>
//               </Grid>

//               <Grid size={{ xs: 12 }}>
//                 <TextField
//                   fullWidth
//                   label="Notes"
//                   multiline
//                   rows={2}
//                   value={orderData.notes}
//                   onChange={(e) =>
//                     setOrderData({ ...orderData, notes: e.target.value })
//                   }
//                   placeholder="Add any special instructions or notes..."
//                   size="small"
//                   variant="outlined"
//                 />
//               </Grid>
//             </Grid>
//           </DialogContent>
//           <DialogActions
//             sx={{ p: 2, borderTop: "1px solid", borderColor: "divider" }}
//           >
//             <Button
//               onClick={() => setOpenEditDialog(false)}
//               variant="outlined"
//               sx={{ borderRadius: 2 }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={handleUpdateOrder}
//               variant="contained"
//               color="primary"
//               disabled={loading}
//               sx={{ borderRadius: 2 }}
//             >
//               {loading ? <CircularProgress size={24} /> : "Update Order"}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Delete Dialog */}
//         <Dialog
//           open={openDeleteDialog}
//           onClose={() => setOpenDeleteDialog(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle sx={{ bgcolor: "#ffebee", py: 2 }}>
//             <Box display="flex" alignItems="center" gap={2}>
//               <Avatar sx={{ bgcolor: "error.main" }}>
//                 <CancelIcon />
//               </Avatar>
//               <Typography
//                 variant="h6"
//                 sx={{ fontWeight: 700, color: "error.main" }}
//               >
//                 Cancel Order
//               </Typography>
//             </Box>
//           </DialogTitle>
//           <DialogContent sx={{ pt: 3 }}>
//             <Alert severity="warning" sx={{ mb: 2, borderRadius: 2 }}>
//               This action cannot be undone. The order will be cancelled
//               permanently.
//             </Alert>
//             <Typography variant="body1" gutterBottom>
//               Are you sure you want to cancel this order?
//             </Typography>
//             {selectedOrder && (
//               <Paper
//                 variant="outlined"
//                 sx={{ p: 2, mt: 2, bgcolor: "#fafafa", borderRadius: 2 }}
//               >
//                 <Typography variant="subtitle2" fontWeight="700" gutterBottom>
//                   Order Summary:
//                 </Typography>
//                 <Grid container spacing={1}>
//                   <Grid size={{ xs: 6 }}>
//                     <Typography variant="body2" color="text.secondary">
//                       Order ID:
//                     </Typography>
//                   </Grid>
//                   <Grid size={{ xs: 6 }}>
//                     <Typography variant="body2" fontWeight="600">
//                       {selectedOrder._id?.slice(-8).toUpperCase()}
//                     </Typography>
//                   </Grid>
//                   <Grid size={{ xs: 6 }}>
//                     <Typography variant="body2" color="text.secondary">
//                       Items:
//                     </Typography>
//                   </Grid>
//                   <Grid size={{ xs: 6 }}>
//                     <Typography variant="body2" fontWeight="600">
//                       {calculateTotalItems(selectedOrder.items)} items
//                     </Typography>
//                   </Grid>
//                   <Grid size={{ xs: 6 }}>
//                     <Typography variant="body2" color="text.secondary">
//                       Total:
//                     </Typography>
//                   </Grid>
//                   <Grid size={{ xs: 6 }}>
//                     <Typography
//                       variant="body2"
//                       fontWeight="700"
//                       color="error.main"
//                     >
//                       {formatCurrency(getOrderTotal(selectedOrder))}
//                     </Typography>
//                   </Grid>
//                 </Grid>
//               </Paper>
//             )}
//           </DialogContent>
//           <DialogActions sx={{ p: 2 }}>
//             <Button
//               onClick={() => setOpenDeleteDialog(false)}
//               variant="outlined"
//               sx={{ borderRadius: 2 }}
//             >
//               No, Keep Order
//             </Button>
//             <Button
//               onClick={handleConfirmDelete}
//               variant="contained"
//               color="error"
//               disabled={loading}
//               sx={{ borderRadius: 2 }}
//             >
//               {loading ? <CircularProgress size={24} /> : "Yes, Cancel Order"}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Status Dialog */}
//         <Dialog
//           open={openStatusDialog}
//           onClose={() => setOpenStatusDialog(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle
//             sx={{ borderBottom: "1px solid", borderColor: "divider" }}
//           >
//             <Box display="flex" alignItems="center" gap={2}>
//               <Avatar sx={{ bgcolor: "info.main" }}>
//                 <TimelineIcon />
//               </Avatar>
//               <Typography variant="h6" sx={{ fontWeight: 700 }}>
//                 Update Order Status
//               </Typography>
//             </Box>
//           </DialogTitle>
//           <DialogContent sx={{ pt: 3 }}>
//             {selectedOrder && (
//               <Box sx={{ mb: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: 2 }}>
//                 <Typography variant="body2" color="text.secondary" gutterBottom>
//                   Current Status:
//                 </Typography>
//                 {getStatusChip(selectedOrder.status)}
//               </Box>
//             )}
//             <FormControl fullWidth sx={{ mt: 1 }}>
//               <InputLabel>New Status</InputLabel>
//               <Select
//                 value={newStatus}
//                 label="New Status"
//                 onChange={(e) => setNewStatus(e.target.value)}
//               >
//                 {statusOptions.map((option) => (
//                   <MenuItem key={option.value} value={option.value}>
//                     <Box display="flex" alignItems="center" gap={1}>
//                       {getStatusIcon(option.value)}
//                       <Typography>{option.label}</Typography>
//                     </Box>
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </DialogContent>
//           <DialogActions
//             sx={{ p: 2, borderTop: "1px solid", borderColor: "divider" }}
//           >
//             <Button
//               onClick={() => setOpenStatusDialog(false)}
//               variant="outlined"
//               sx={{ borderRadius: 2 }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={handleStatusUpdate}
//               variant="contained"
//               color="primary"
//               disabled={
//                 loading || !newStatus || newStatus === selectedOrder?.status
//               }
//               sx={{ borderRadius: 2 }}
//             >
//               {loading ? <CircularProgress size={24} /> : "Update Status"}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* ⭐ Update Payment Status Dialog (Supports REFUND_PENDING) */}
//         <Dialog
//           open={openPaymentStatusDialog}
//           onClose={() => setOpenPaymentStatusDialog(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
//             <Box display="flex" alignItems="center" gap={2}>
//               <Avatar sx={{ bgcolor: "success.main" }}>
//                 <PaymentIcon />
//               </Avatar>
//               <Typography variant="h6" sx={{ fontWeight: 700 }}>
//                 Update Payment Status
//               </Typography>
//             </Box>
//           </DialogTitle>
//           <DialogContent sx={{ pt: 3 }}>
//             {selectedOrder && (
//               <Box sx={{ mb: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: 2 }}>
//                 <Typography variant="body2" color="text.secondary" gutterBottom>
//                   Order: {selectedOrder._id?.slice(-8).toUpperCase()}
//                 </Typography>
//                 <Typography variant="body1" fontWeight="600">
//                   Amount: {formatCurrency(getOrderTotal(selectedOrder))}
//                 </Typography>
//               </Box>
//             )}
//             <FormControl fullWidth sx={{ mt: 2 }}>
//               <InputLabel>Payment Status</InputLabel>
//               <Select
//                 value={newPaymentStatus}
//                 label="Payment Status"
//                 onChange={(e) => setNewPaymentStatus(e.target.value)}
//               >
//                 {paymentStatusOptions.map((option) => (
//                   <MenuItem key={option.value} value={option.value}>
//                     <Box display="flex" alignItems="center" gap={1}>
//                       {option.value === "PAID" && (
//                         <CheckCircleIcon
//                           sx={{ color: "success.main" }}
//                           fontSize="small"
//                         />
//                       )}
//                       {option.value === "PENDING" && (
//                         <PendingIcon
//                           sx={{ color: "warning.main" }}
//                           fontSize="small"
//                         />
//                       )}
//                       {option.value === "FAILED" && (
//                         <CancelIcon
//                           sx={{ color: "error.main" }}
//                           fontSize="small"
//                         />
//                       )}
//                       {option.value === "REFUND_PENDING" && (
//                         <RefundIcon
//                           sx={{ color: "error.main" }}
//                           fontSize="small"
//                         />
//                       )}
//                       {option.value === "REFUNDED" && (
//                         <PaymentIcon
//                           sx={{ color: "info.main" }}
//                           fontSize="small"
//                         />
//                       )}
//                       <Typography>{option.label}</Typography>
//                     </Box>
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </DialogContent>
//           <DialogActions
//             sx={{ p: 2, borderTop: "1px solid", borderColor: "divider" }}
//           >
//             <Button
//               onClick={() => setOpenPaymentStatusDialog(false)}
//               variant="outlined"
//               sx={{ borderRadius: 2 }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={handlePaymentStatusDialogUpdate}
//               variant="contained"
//               color="success"
//               disabled={!newPaymentStatus}
//               sx={{ borderRadius: 2 }}
//             >
//               Update Payment
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Date Range Dialog */}
//         <Dialog
//           open={openDateRangeDialog}
//           onClose={() => setOpenDateRangeDialog(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
//             <Box display="flex" alignItems="center" gap={2}>
//               <Avatar sx={{ bgcolor: "primary.main" }}>
//                 <DateRangeIcon />
//               </Avatar>
//               <Typography variant="h6" sx={{ fontWeight: 700 }}>
//                 Select Date Range
//               </Typography>
//             </Box>
//           </DialogTitle>
//           <DialogContent sx={{ pt: 3 }}>
//             <DatePicker
//               label="Start Date"
//               value={dateRange.startDate}
//               onChange={(newValue) =>
//                 setDateRange({ ...dateRange, startDate: newValue })
//               }
//               slotProps={{
//                 textField: {
//                   fullWidth: true,
//                   margin: "normal",
//                   size: "small",
//                   sx: { mb: 2 },
//                 },
//               }}
//             />
//             <DatePicker
//               label="End Date"
//               value={dateRange.endDate}
//               onChange={(newValue) =>
//                 setDateRange({ ...dateRange, endDate: newValue })
//               }
//               slotProps={{
//                 textField: {
//                   fullWidth: true,
//                   margin: "normal",
//                   size: "small",
//                 },
//               }}
//             />
//           </DialogContent>
//           <DialogActions
//             sx={{ p: 2, borderTop: "1px solid", borderColor: "divider" }}
//           >
//             <Button
//               onClick={() => setOpenDateRangeDialog(false)}
//               variant="outlined"
//               sx={{ borderRadius: 2 }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={handleDateRangeApply}
//               variant="contained"
//               color="primary"
//               disabled={!dateRange.startDate || !dateRange.endDate}
//               sx={{ borderRadius: 2 }}
//             >
//               Apply Filter
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Snackbars */}
//         <Snackbar
//           open={!!error}
//           autoHideDuration={6000}
//           onClose={handleCloseSnackbar}
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         >
//           <Alert
//             onClose={handleCloseSnackbar}
//             severity="error"
//             variant="filled"
//             sx={{ width: "100%", borderRadius: 2 }}
//           >
//             {error}
//           </Alert>
//         </Snackbar>

//         <Snackbar
//           open={!!success}
//           autoHideDuration={6000}
//           onClose={handleCloseSnackbar}
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         >
//           <Alert
//             onClose={handleCloseSnackbar}
//             severity="success"
//             variant="filled"
//             sx={{ width: "100%", borderRadius: 2 }}
//           >
//             {success === true ? "Operation completed successfully!" : success}
//           </Alert>
//         </Snackbar>
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default Orders;

import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Typography,
  Grid,
  Alert,
  Snackbar,
  Tooltip,
  CircularProgress,
  InputAdornment,
  TableSortLabel,
  Stack,
  Divider,
  Avatar,
  Menu,
  Autocomplete,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Refresh as RefreshIcon,
  DateRange as DateRangeIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Pending as PendingIcon,
  LocalShipping as ShippingIcon,
  DoneAll as DeliveredIcon,
  Timeline as TimelineIcon,
  ShoppingCart as CartIcon,
  LocalOffer as OfferIcon,
  Payment as PaymentIcon,
  Search as SearchIcon,
  CurrencyExchange as RefundIcon,
  DirectionsBike as DirectionsBikeIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import PhoneIcon from "@mui/icons-material/Phone";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import TakeoutDiningIcon from "@mui/icons-material/TakeoutDining";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";

// Redux imports
import { useDispatch, useSelector } from "react-redux";
import { useSocket } from "../../context/SocketContext";
import {
  fetchAllOrders,
  changeOrderStatus,
  updateOrderDetails,
  cancelOrder,
  fetchOrderStats,
  clearError,
  clearSuccess,
  setFilters,
} from "../../redux/slices/orderSlice";
import {
  getPayments,
  updatePaymentStatus,
  selectPayments,
  selectPaymentsLoading,
  selectPaymentsPagination,
} from "../../redux/slices/paymentsSlice";
import { fetchMenu, selectMenuList } from "../../redux/slices/menuSlice"; // 👈 API Menu Fetch

import axiosInstance from "../../utils/axios";

const Orders = () => {
  const dispatch = useDispatch();
  const { socket, isConnected } = useSocket();
  const { orders, loading, error, success, totalOrders, filters } = useSelector(
    (state) => state.order,
  );
  const payments = useSelector(selectPayments);

  // ⭐ Redux se Restaurant ka live Menu
  const availableMenuItems = useSelector(selectMenuList) || [];

  // Local states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [openDateRangeDialog, setOpenDateRangeDialog] = useState(false);
  const [openPaymentStatusDialog, setOpenPaymentStatusDialog] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const [notification, setNotification] = useState(null);

  // ⭐ orderType state added in orderData
  const [orderData, setOrderData] = useState({
    name: "",
    phone: "",
    address: "",
    orderType: "DINE_IN",
    items: [],
    deliveryCharge: 0,
    totalAmount: 0,
    notes: "",
  });
  const [newStatus, setNewStatus] = useState("");
  const [newPaymentStatus, setNewPaymentStatus] = useState("");
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [sortConfig, setSortConfig] = useState({
    field: "createdAt",
    direction: "desc",
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState(null);

  // ⭐ New item form state (Sizes, Variants, Addons include)
  const [newItem, setNewItem] = useState({
    selectedMenu: null,
    itemName: "",
    price: 0,
    quantity: 1,
    selectedSize: null,
    selectedVariant: null,
    selectedAddons: [],
  });

  const statusOptions = [
    { value: "PENDING", label: "Pending", color: "warning" },
    { value: "ACCEPTED", label: "Accepted", color: "info" },
    { value: "PREPARING", label: "Processing", color: "secondary" },
    { value: "OUT_FOR_DELIVERY", label: "Out For Delivery", color: "warning" },
    { value: "COMPLETED", label: "Completed", color: "primary" },
    { value: "DELIVERED", label: "Delivered", color: "success" },
    { value: "CANCELLED", label: "Cancelled", color: "error" },
  ];

  const paymentStatusOptions = [
    { value: "PENDING", label: "Pending", color: "warning" },
    { value: "PAID", label: "Paid", color: "success" },
    { value: "FAILED", label: "Failed", color: "error" },
    { value: "REFUND_PENDING", label: "Refund Pending", color: "error" },
    { value: "REFUNDED", label: "Refunded", color: "info" },
  ];

  const orderTypeOptions = [
    {
      value: "DINE_IN",
      label: "Dine In",
      color: "success",
      icon: <RestaurantIcon fontSize="small" />,
    },
    {
      value: "TAKEAWAY",
      label: "Takeaway",
      color: "secondary",
      icon: <TakeoutDiningIcon fontSize="small" />,
    },
    {
      value: "DELIVERY",
      label: "Delivery",
      color: "error",
      icon: <DeliveryDiningIcon fontSize="small" />,
    },
  ];

  const paymentMethodOptions = [
    { value: "CASH", label: "Cash", icon: "💵", color: "#2E7D32" },
    { value: "UPI", label: "UPI", icon: "📱", color: "#1565C0" },
    { value: "PHONEPE", label: "PHONEPE", icon: "💳", color: "#5E35B1" },
    { value: "ONLINE", label: "Online", icon: "🌐", color: "#EF6C00" },
    { value: "WALLET", label: "Wallet", icon: "👛", color: "#C2185B" },
  ];

  const getOrderTotal = (order) => {
    return order.orderSummary?.totalAmount || order.totalAmount || 0;
  };

  const getOrderSubtotal = (order) => {
    return order.orderSummary?.subtotal || order.totalAmount || 0;
  };

  const getOrderDiscount = (order) => {
    return order.orderSummary?.totalDiscount || 0;
  };

  const getOrderDeliveryCharge = (order) => {
    return Number(
      order.orderSummary?.deliveryCharge ?? order.deliveryCharge ?? 0,
    );
  };

  const getOrderPayment = (orderId) => {
    return payments?.find(
      (p) => p.order?._id === orderId || p.order === orderId,
    );
  };

  const getPaymentStatusChip = (status) => {
    const statusOption = paymentStatusOptions.find(
      (opt) => opt.value === status,
    );
    return (
      <Chip
        label={statusOption?.label || status}
        color={statusOption?.color || "default"}
        size="small"
        icon={
          status === "REFUND_PENDING" ? (
            <RefundIcon sx={{ fontSize: "14px !important" }} />
          ) : (
            <PaymentIcon />
          )
        }
        sx={{ fontWeight: 600, minWidth: 80 }}
      />
    );
  };

  const getPaymentMethodChip = (method) => {
    const methodOption = paymentMethodOptions.find(
      (opt) => opt.value === method,
    );
    return (
      <Chip
        label={methodOption?.label || method}
        size="small"
        sx={{
          fontWeight: 500,
          backgroundColor: methodOption?.color || "#e0e0e0",
          color: "#fff",
          "& .MuiChip-icon": { color: "#fff" },
        }}
      />
    );
  };

  const calculateItemTotal = (item) => {
    const basePrice = item.selectedSize?.price || item.price || 0;
    const variantPrice = item.selectedVariant?.price || 0;
    const addonsTotal =
      item.selectedAddons?.reduce((sum, a) => sum + (a.price || 0), 0) || 0;
    return (basePrice + variantPrice + addonsTotal) * (item.quantity || 1);
  };

  const calculateTotalItems = (items) => {
    return items?.reduce((total, item) => total + (item.quantity || 0), 0) || 0;
  };

  const calculateTotalAmount = (items, deliveryCharge = 0) => {
    const itemsTotal =
      items?.reduce((total, item) => {
        return total + (item.total || calculateItemTotal(item));
      }, 0) || 0;
    return itemsTotal + Number(deliveryCharge || 0);
  };

  const formatDate = (dateString) => {
    return format(new Date(dateString), "dd/MM/yyyy HH:mm");
  };

  const formatCurrency = (amount) => {
    return `₹${Number(amount || 0).toFixed(2)}`;
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "PENDING":
        return <PendingIcon />;
      case "ACCEPTED":
        return <CheckCircleIcon />;
      case "PREPARING":
        return <TimelineIcon />;
      case "OUT_FOR_DELIVERY":
        return <DeliveryDiningIcon />;
      case "COMPLETED":
        return <ShippingIcon />;
      case "DELIVERED":
        return <DeliveredIcon />;
      case "CANCELLED":
        return <CancelIcon />;
      default:
        return null;
    }
  };

  const getStatusChip = (status) => {
    const statusOption = statusOptions.find((opt) => opt.value === status);
    return (
      <Chip
        label={statusOption?.label || status}
        color={statusOption?.color || "default"}
        size="small"
        icon={getStatusIcon(status)}
        sx={{ fontWeight: 600, minWidth: 90 }}
      />
    );
  };

  const getOrderTypeChip = (orderType) => {
    const selectedType = orderTypeOptions.find(
      (opt) => opt.value === orderType,
    );
    return (
      <Chip
        icon={selectedType?.icon}
        label={selectedType?.label || orderType}
        color={selectedType?.color || "default"}
        size="small"
        variant="filled"
        sx={{ fontWeight: 600, minWidth: 90 }}
      />
    );
  };

  const fetchOrders = async (showLoading = true, searchParams = null) => {
    try {
      const params = searchParams || filters;
      if (showLoading) {
        await dispatch(fetchAllOrders(params));
        await dispatch(getPayments({ page: 1, limit: 100 }));
      } else {
        await dispatch(fetchAllOrders(params));
      }
    } catch (error) {
      console.error("Fetch orders error:", error);
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    const updatedFilters = {
      ...filters,
      search: query,
      page: 1,
    };
    dispatch(setFilters(updatedFilters));
    setPage(0);
  };

  const handleSearchToggle = () => {
    setSearchOpen(!searchOpen);
    if (searchOpen) {
      setSearchQuery("");
      const updatedFilters = {
        ...filters,
        search: "",
        page: 1,
      };
      dispatch(setFilters(updatedFilters));
      setPage(0);
    }
  };

  const getFilteredOrders = () => {
    if (!searchQuery.trim()) return orders;
    const query = searchQuery.toLowerCase().trim();
    return orders?.filter((order) => {
      const orderIdLast8 = order._id?.slice(-8).toUpperCase() || "";
      if (orderIdLast8.includes(query.toUpperCase())) return true;
      if (order._id?.toLowerCase().includes(query)) return true;
      if (order.customer?.name?.toLowerCase().includes(query)) return true;
      if (order.customer?.phone?.includes(query)) return true;
      if (
        order.items?.some((item) =>
          item.itemName?.toLowerCase().includes(query),
        )
      )
        return true;
      return false;
    });
  };

  const displayedOrders = getFilteredOrders();

  const handleManualRefresh = () => {
    fetchOrders(true, filters);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const updatedFilters = { ...filters, page: newPage + 1 };
    dispatch(setFilters(updatedFilters));
    fetchOrders(true, updatedFilters);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    const updatedFilters = { ...filters, limit: newRowsPerPage, page: 1 };
    dispatch(setFilters(updatedFilters));
    fetchOrders(true, updatedFilters);
  };

  const handleSort = (field) => {
    const direction =
      sortConfig.field === field && sortConfig.direction === "asc"
        ? "desc"
        : "asc";
    setSortConfig({ field, direction });
    const updatedFilters = { ...filters, sortBy: field, sortOrder: direction };
    dispatch(setFilters(updatedFilters));
    fetchOrders(true, updatedFilters);
  };

  const handleFilterChange = (field, value) => {
    const updatedFilters = { ...filters, [field]: value, page: 1 };
    dispatch(setFilters(updatedFilters));
    fetchOrders(true, updatedFilters);
    setPage(0);
  };

  const handleDateRangeApply = () => {
    if (dateRange.startDate && dateRange.endDate) {
      const formattedStartDate = format(dateRange.startDate, "yyyy-MM-dd");
      const formattedEndDate = format(dateRange.endDate, "yyyy-MM-dd");
      const updatedFilters = {
        ...filters,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        page: 1,
      };
      dispatch(setFilters(updatedFilters));
      fetchOrders(true, updatedFilters);
      setOpenDateRangeDialog(false);
    }
  };

  const handleClearFilters = () => {
    const updatedFilters = {
      status: "",
      orderType: "",
      startDate: "",
      endDate: "",
      search: "",
      page: 1,
      limit: rowsPerPage,
    };
    dispatch(setFilters(updatedFilters));
    fetchOrders(true, updatedFilters);
    setPage(0);
    setDateRange({ startDate: null, endDate: null });
    setSearchQuery("");
  };

  const handleViewOrder = (order) => {
    setSelectedOrder(order);
    setOpenViewDialog(true);
  };

  const handleEditOrder = (order) => {
    setSelectedOrder(order);
    const deliveryFee = getOrderDeliveryCharge(order);
    setOrderData({
      name: order.customer?.name || "",
      phone: order.customer?.phone || "",
      address: order.customer?.address || "",
      orderType: order.orderType || "DINE_IN",
      items: order.items.map((item) => ({
        ...item,
        selectedSize: item.selectedSize || null,
        selectedVariant: item.selectedVariant || null,
        selectedAddons: item.selectedAddons || [],
        total: item.total || calculateItemTotal(item),
      })),
      deliveryCharge: deliveryFee,
      totalAmount: getOrderTotal(order),
      notes: order.notes || "",
    });
    setNewItem({
      selectedMenu: null,
      itemName: "",
      price: 0,
      quantity: 1,
      selectedSize: null,
      selectedVariant: null,
      selectedAddons: [],
    });
    setOpenEditDialog(true);
  };

  // Helper to re-evaluate single item price
  const computePrice = (menuObj, sizeObj, variantObj, addons) => {
    if (!menuObj) return 0;
    let base = Number(sizeObj?.price ?? (menuObj.basePrice || menuObj.price || 0));
    if (variantObj?.price) {
      base += Number(variantObj.price);
    }
    if (addons && addons.length > 0) {
      addons.forEach((ad) => {
        base += Number(ad.price || 0);
      });
    }
    return Math.round(base * 100) / 100;
  };

  // Item select hone par auto price populate
  const handleSelectMenuItem = (menuObj) => {
    if (!menuObj) {
      setNewItem({
        selectedMenu: null,
        itemName: "",
        price: 0,
        quantity: 1,
        selectedSize: null,
        selectedVariant: null,
        selectedAddons: [],
      });
      return;
    }
    const calculatedPrice = computePrice(menuObj, null, null, []);
    setNewItem({
      selectedMenu: menuObj,
      itemName: menuObj.itemName,
      price: calculatedPrice,
      quantity: 1,
      selectedSize: null,
      selectedVariant: null,
      selectedAddons: [],
    });
  };

  // Size change handler for new item
  const handleSizeChange = (sizeName) => {
    const sizeObj = newItem.selectedMenu?.sizes?.find((s) => s.name === sizeName) || null;
    const newPrice = computePrice(newItem.selectedMenu, sizeObj, newItem.selectedVariant, newItem.selectedAddons);
    setNewItem({
      ...newItem,
      selectedSize: sizeObj,
      price: newPrice,
    });
  };

  // Variant change handler for new item
  const handleVariantChange = (variantName) => {
    const variantObj = newItem.selectedMenu?.variants?.find((v) => v.name === variantName) || null;
    const newPrice = computePrice(newItem.selectedMenu, newItem.selectedSize, variantObj, newItem.selectedAddons);
    setNewItem({
      ...newItem,
      selectedVariant: variantObj,
      price: newPrice,
    });
  };

  // Addon checkbox toggle handler for new item
  const handleAddonToggle = (addon) => {
    let updatedAddons = [...newItem.selectedAddons];
    const exists = updatedAddons.some((a) => a.name === addon.name);
    if (exists) {
      updatedAddons = updatedAddons.filter((a) => a.name !== addon.name);
    } else {
      updatedAddons.push({ name: addon.name, price: Number(addon.price || 0) });
    }
    const newPrice = computePrice(newItem.selectedMenu, newItem.selectedSize, newItem.selectedVariant, updatedAddons);
    setNewItem({
      ...newItem,
      selectedAddons: updatedAddons,
      price: newPrice,
    });
  };

  // ⭐ NAYA ITEM LIST ME ADD KARNE KA FUNCTION
  const handleAddNewItem = () => {
    if (!newItem.itemName || newItem.quantity <= 0) return;

    const unitPrice = Number(newItem.price || 0);
    const qty = Number(newItem.quantity || 1);

    const newItemObj = {
      _id: `temp-${Date.now()}`,
      itemId: newItem.selectedMenu?._id || null,
      itemName: newItem.itemName,
      price: unitPrice,
      originalPrice: unitPrice,
      quantity: qty,
      total: unitPrice * qty,
      selectedSize: newItem.selectedSize,
      selectedVariant: newItem.selectedVariant,
      selectedAddons: newItem.selectedAddons,
    };

    const updatedItems = [...orderData.items, newItemObj];
    const newTotalAmount = calculateTotalAmount(updatedItems, orderData.deliveryCharge);

    setOrderData({
      ...orderData,
      items: updatedItems,
      totalAmount: newTotalAmount,
    });

    // Form reset
    setNewItem({
      selectedMenu: null,
      itemName: "",
      price: 0,
      quantity: 1,
      selectedSize: null,
      selectedVariant: null,
      selectedAddons: [],
    });
  };

  // Existing item remove karne ka handler
  const handleRemoveItem = (index) => {
    if (orderData.items.length <= 1) {
      alert("Order me kam se kam 1 item hona anivarya hai!");
      return;
    }
    const updatedItems = orderData.items.filter((_, i) => i !== index);
    const newTotalAmount = calculateTotalAmount(updatedItems, orderData.deliveryCharge);
    setOrderData({
      ...orderData,
      items: updatedItems,
      totalAmount: newTotalAmount,
    });
  };

  const handleUpdateOrder = () => {
    const updatedData = {
      ...orderData,
      totalAmount: calculateTotalAmount(
        orderData.items,
        orderData.deliveryCharge,
      ),
    };

    dispatch(
      updateOrderDetails({
        orderId: selectedOrder._id,
        data: updatedData,
      }),
    ).then(() => {
      setOpenEditDialog(false);
      fetchOrders(true, filters);
    });
  };

  const handleDeleteClick = (order) => {
    setSelectedOrder(order);
    setOpenDeleteDialog(true);
  };

  const handleConfirmDelete = () => {
    dispatch(cancelOrder(selectedOrder._id)).then(() => {
      setOpenDeleteDialog(false);
      fetchOrders(true, filters);
    });
  };

  const handleStatusClick = (order) => {
    setSelectedOrder(order);
    setNewStatus(order.status);
    setOpenStatusDialog(true);
  };

  const handleStatusUpdate = () => {
    dispatch(
      changeOrderStatus({
        orderId: selectedOrder._id,
        status: newStatus,
      }),
    ).then(() => {
      setOpenStatusDialog(false);
      fetchOrders(true, filters);
    });
  };

  const handlePaymentStatusMenu = (event, order) => {
    setAnchorEl(event.currentTarget);
    setSelectedOrder(order);
    const payment = getOrderPayment(order._id);
    setSelectedPayment(payment);
  };

  const handlePaymentStatusChange = async (status) => {
    try {
      if (status === "REFUNDED" && selectedOrder) {
        const res = await axiosInstance.put(
          `/api/orders/${selectedOrder._id}/settle-refund`,
        );
        if (res.data.success) {
          fetchOrders(false, filters);
          dispatch(fetchOrderStats());
        }
      } else if (selectedPayment) {
        await dispatch(
          updatePaymentStatus({
            id: selectedPayment._id,
            statusData: { status },
          }),
        );
        dispatch(getPayments({ page: 1, limit: 100 }));
        fetchOrders(false, filters);
      } else if (selectedOrder) {
        setNewPaymentStatus(status);
        setOpenPaymentStatusDialog(true);
      }
    } catch (err) {
      console.error("Status update error:", err);
    } finally {
      setAnchorEl(null);
    }
  };

  const handlePaymentStatusDialogUpdate = async () => {
    try {
      if (newPaymentStatus === "REFUNDED" && selectedOrder) {
        const res = await axiosInstance.put(
          `/api/orders/${selectedOrder._id}/settle-refund`,
        );
        if (res.data.success) {
          fetchOrders(false, filters);
          dispatch(fetchOrderStats());
        }
      } else if (selectedOrder) {
        await axiosInstance.put(`/api/orders/${selectedOrder._id}`, {
          paymentStatus: newPaymentStatus,
        });
        fetchOrders(false, filters);
      }
    } catch (err) {
      console.error("Payment status update error:", err);
    } finally {
      setOpenPaymentStatusDialog(false);
    }
  };

  const handleCloseSnackbar = () => {
    dispatch(clearError());
    dispatch(clearSuccess());
  };

  const handleClosePaymentMenu = () => {
    setAnchorEl(null);
    setSelectedPayment(null);
  };

  useEffect(() => {
    const initialFetch = async () => {
      await dispatch(fetchAllOrders(filters));
      await dispatch(getPayments({ page: 1, limit: 100 }));
      await dispatch(fetchOrderStats());
      await dispatch(fetchMenu()); // Restaurant Menu Items load karein
    };
    initialFetch();
  }, []);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => dispatch(clearSuccess()), 3000);
      return () => clearTimeout(timer);
    }
    if (error) {
      const timer = setTimeout(() => dispatch(clearError()), 5000);
      return () => clearTimeout(timer);
    }
  }, [success, error, dispatch]);

  useEffect(() => {
    if (!socket) return;
    socket.on("new-order", (data) => {
      setNotification({
        message: `🆕 New order from ${data.order.customer?.name || "Customer"}!`,
        severity: "success",
        order: data.order,
      });
      playNotificationSound();
      showBrowserNotification(data.order);
      fetchOrders(true);
    });

    socket.on("order-status-updated", (data) => {
      fetchOrders(true);
      setNotification({
        message: `Order #${data.order._id?.slice(-6)} status: ${data.order.status}`,
        severity: "info",
        order: data.order,
      });
    });

    socket.on("order-cancelled", (data) => {
      fetchOrders(true);
      setNotification({
        message: `Order #${data.orderId?.slice(-6)} has been cancelled`,
        severity: "error",
        order: data.order,
      });
    });

    socket.on("order-updated", () => {
      fetchOrders(true);
    });

    return () => {
      socket.off("new-order");
      socket.off("order-status-updated");
      socket.off("order-cancelled");
      socket.off("order-updated");
    };
  }, [socket]);

  const playNotificationSound = () => {
    try {
      const audio = new Audio("/sounds/notification.mp3");
      audio.volume = 0.5;
      audio.play().catch(() => {});
    } catch (e) {}
  };

  const showBrowserNotification = (order) => {
    if (window.Notification && Notification.permission === "granted") {
      const customerName = order.customer?.name || "Customer";
      const totalAmount =
        order.orderSummary?.totalAmount || order.totalAmount || 0;
      new Notification(`New Order from ${customerName}!`, {
        body: `Amount: ₹${totalAmount} | Order Type: ${order.orderType}`,
        icon: "🍽️",
        tag: `order-${order._id}`,
        requireInteraction: true,
      });
    }
  };

  useEffect(() => {
    if (window.Notification && Notification.permission === "default") {
      Notification.requestPermission();
    }
  }, []);

  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => setNotification(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  if (loading && !orders.length) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ mb: 4 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            gap={2}
          >
            <Box>
              <Typography
                variant="h4"
                component="h1"
                sx={{ fontWeight: 700, color: "#1a365d", mb: 1 }}
              >
                Orders Management
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Track, manage and update all customer orders
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
              <Button
                variant="contained"
                startIcon={
                  loading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <RefreshIcon />
                  )
                }
                onClick={handleManualRefresh}
                disabled={loading}
                sx={{ borderRadius: 2, px: 3 }}
              >
                Refresh
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Search & Filter Bar */}
        <Box
          sx={{
            mb: 3,
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ flex: 1, minWidth: { xs: "100%", sm: 250 } }}>
            {searchOpen ? (
              <TextField
                fullWidth
                size="small"
                placeholder="Search by ID, customer, phone, item..."
                value={searchQuery}
                onChange={handleSearch}
                autoFocus
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={handleSearchToggle}>
                        <CancelIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{ borderRadius: 2 }}
              />
            ) : (
              <Button
                variant="outlined"
                startIcon={<SearchIcon />}
                onClick={handleSearchToggle}
                sx={{ borderRadius: 2, textTransform: "none" }}
              >
                Search Orders
              </Button>
            )}
          </Box>

          <FormControl size="small" sx={{ minWidth: 130 }}>
            <InputLabel>Status</InputLabel>
            <Select
              value={filters.status || ""}
              label="Status"
              onChange={(e) => handleFilterChange("status", e.target.value)}
            >
              <MenuItem value="">All</MenuItem>
              {statusOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ minWidth: 130 }}>
            <InputLabel>Order Type</InputLabel>
            <Select
              value={filters.orderType || ""}
              label="Order Type"
              onChange={(e) => handleFilterChange("orderType", e.target.value)}
            >
              <MenuItem value="">All</MenuItem>
              {orderTypeOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="outlined"
            startIcon={<DateRangeIcon />}
            onClick={() => setOpenDateRangeDialog(true)}
            sx={{ borderRadius: 2, textTransform: "none" }}
          >
            {dateRange.startDate && dateRange.endDate
              ? `${format(dateRange.startDate, "dd/MM")} - ${format(dateRange.endDate, "dd/MM")}`
              : "Date Range"}
          </Button>

          {(filters.status ||
            filters.orderType ||
            filters.startDate ||
            filters.endDate ||
            searchQuery) && (
            <Button
              size="small"
              color="error"
              onClick={handleClearFilters}
              sx={{ borderRadius: 2, textTransform: "none" }}
            >
              Clear Filters
            </Button>
          )}
        </Box>

        {/* Table Paper */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: 3,
            border: "1px solid",
            borderColor: "divider",
            overflow: "hidden",
          }}
        >
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "action.hover" }}>
                  <TableCell sx={{ fontWeight: 700 }}>#</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Order ID</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Table</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Items</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Customer</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Amount</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Discount</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Order Status</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Payment Method</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Payment Status</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>
                    <TableSortLabel
                      active={sortConfig.field === "createdAt"}
                      direction={
                        sortConfig.field === "createdAt"
                          ? sortConfig.direction
                          : "asc"
                      }
                      onClick={() => handleSort("createdAt")}
                    >
                      Date
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 700 }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {displayedOrders?.map((order, index) => {
                  const totalAmount = getOrderTotal(order);
                  const discountAmount = getOrderDiscount(order);
                  const subtotal = getOrderSubtotal(order);
                  const payment = getOrderPayment(order._id);

                  return (
                    <TableRow
                      key={order?._id}
                      hover
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell>
                        <Typography variant="body2" fontWeight={500}>
                          #{page * rowsPerPage + index + 1}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={order._id?.slice(-8).toUpperCase()}
                          size="small"
                          sx={{
                            fontFamily: "monospace",
                            fontSize: "0.7rem",
                            bgcolor: "#f5f5f5",
                            fontWeight: 600,
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        {order.tableNumber ? (
                          <Chip
                            label={`Table ${order.tableNumber}`}
                            size="small"
                            color="primary"
                            variant="outlined"
                            sx={{ fontWeight: 600 }}
                          />
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography
                            variant="body2"
                            fontWeight="600"
                            color="primary.main"
                          >
                            {calculateTotalItems(order.items)}{" "}
                            {calculateTotalItems(order.items) === 1
                              ? "item"
                              : "items"}
                          </Typography>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: "block" }}
                          >
                            {order.items?.[0]?.itemName}
                            {order.items?.length > 1 &&
                              ` +${order.items.length - 1} more`}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        {getOrderTypeChip(order?.orderType)}
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight={500}>
                          {order.customer?.name || "-"}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {order.customer?.phone || "-"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box>
                          {discountAmount > 0 ? (
                            <>
                              <Typography
                                variant="body2"
                                sx={{
                                  textDecoration: "line-through",
                                  color: "#999",
                                }}
                              >
                                {formatCurrency(subtotal)}
                              </Typography>
                              <Typography
                                variant="body1"
                                fontWeight="700"
                                color="success.main"
                              >
                                {formatCurrency(totalAmount)}
                              </Typography>
                            </>
                          ) : (
                            <Typography
                              variant="body1"
                              fontWeight="700"
                              color="primary.main"
                            >
                              {formatCurrency(totalAmount)}
                            </Typography>
                          )}
                        </Box>

                        {Number(order.orderSummary?.refundDue || 0) > 0 && (
                          <Chip
                            label={`Refund Due: ₹${Number(order.orderSummary.refundDue).toFixed(2)}`}
                            size="small"
                            sx={{
                              mt: 0.5,
                              height: 18,
                              fontSize: "0.6rem",
                              fontWeight: 800,
                              bgcolor: "#ffebee",
                              color: "#c62828",
                              border: "1px solid #ffcdd2",
                            }}
                          />
                        )}
                      </TableCell>

                      <TableCell>
                        {discountAmount > 0 ? (
                          <Chip
                            label={`-${formatCurrency(discountAmount)}`}
                            size="small"
                            color="success"
                            icon={<OfferIcon sx={{ fontSize: "0.8rem" }} />}
                            sx={{ fontWeight: 600 }}
                          />
                        ) : (
                          <Typography variant="caption" color="text.secondary">
                            —
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Box
                          onClick={() => handleStatusClick(order)}
                          sx={{ cursor: "pointer" }}
                        >
                          {getStatusChip(order.status)}
                        </Box>
                      </TableCell>
                      <TableCell>
                        {payment?.method || order.paymentMethod ? (
                          getPaymentMethodChip(payment?.method || order.paymentMethod)
                        ) : (
                          <Typography variant="caption" color="text.secondary">
                            —
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Box
                          onClick={(e) => handlePaymentStatusMenu(e, order)}
                          sx={{ cursor: "pointer" }}
                        >
                          {getPaymentStatusChip(
                            payment?.status || order.paymentStatus || "PENDING",
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="caption" fontWeight={500}>
                          {formatDate(order.createdAt)}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Stack
                          direction="row"
                          spacing={1}
                          justifyContent="center"
                        >
                          <Tooltip title="View Details">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleViewOrder(order)}
                              sx={{
                                bgcolor: "primary.light",
                                color: "white",
                                "&:hover": { bgcolor: "primary.main" },
                              }}
                            >
                              <ViewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit Order">
                            <IconButton
                              size="small"
                              color="secondary"
                              onClick={() => handleEditOrder(order)}
                              disabled={
                                order.status === "CANCELLED" ||
                                order.status === "DELIVERED"
                              }
                              sx={{
                                bgcolor: "secondary.light",
                                color: "white",
                                "&:hover": { bgcolor: "secondary.main" },
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Cancel Order">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleDeleteClick(order)}
                              disabled={
                                order.status === "CANCELLED" ||
                                order.status === "DELIVERED"
                              }
                              sx={{
                                bgcolor: "error.light",
                                color: "white",
                                "&:hover": { bgcolor: "error.main" },
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          {orders?.length === 0 && !loading && (
            <Box sx={{ p: 8, textAlign: "center" }}>
              <CartIcon sx={{ fontSize: 60, color: "#e0e0e0", mb: 2 }} />
              <Typography variant="h6" color="text.secondary" gutterBottom>
                No orders found
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Try changing your filters or create a new order
              </Typography>
            </Box>
          )}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={totalOrders}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{ borderTop: "1px solid", borderColor: "divider" }}
          />
        </Paper>

        {/* Payment Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClosePaymentMenu}
        >
          <MenuItem onClick={() => handlePaymentStatusChange("PAID")}>
            <CheckCircleIcon
              sx={{ mr: 1, color: "success.main" }}
              fontSize="small"
            />
            Mark as Paid
          </MenuItem>
          <MenuItem onClick={() => handlePaymentStatusChange("PENDING")}>
            <PendingIcon
              sx={{ mr: 1, color: "warning.main" }}
              fontSize="small"
            />
            Mark as Pending
          </MenuItem>
          <MenuItem onClick={() => handlePaymentStatusChange("REFUND_PENDING")}>
            <RefundIcon
              sx={{ mr: 1, color: "error.main" }}
              fontSize="small"
            />
            Mark as Refund Pending
          </MenuItem>
          <MenuItem onClick={() => handlePaymentStatusChange("REFUNDED")}>
            <PaymentIcon sx={{ mr: 1, color: "info.main" }} fontSize="small" />
            Mark as Refunded
          </MenuItem>
          <MenuItem onClick={() => handlePaymentStatusChange("FAILED")}>
            <CancelIcon sx={{ mr: 1, color: "error.main" }} fontSize="small" />
            Mark as Failed
          </MenuItem>
        </Menu>

        {/* View Order Dialog */}
        <Dialog
          open={openViewDialog}
          onClose={() => setOpenViewDialog(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle
            sx={{ borderBottom: "1px solid", borderColor: "divider", pb: 2 }}
          >
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar sx={{ bgcolor: "primary.main" }}>
                <CartIcon />
              </Avatar>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  Order Details
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Order ID: {selectedOrder?._id}
                </Typography>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 3 }}>
            {selectedOrder && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: 3,
                    mb: 4,
                  }}
                >
                  {/* <Box
                    sx={{ flex: 1, p: 2, bgcolor: "#f8fafc", borderRadius: 2 }}
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight="700"
                      gutterBottom
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <Avatar
                        sx={{ width: 24, height: 24, bgcolor: "primary.light" }}
                      >
                        👤
                      </Avatar>
                      Customer Information
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <Grid container spacing={1.5}>
                      <Grid size={{ xs: 4 }}>
                        <Typography variant="body2" color="text.secondary">
                          Name:
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 8 }}>
                        <Typography variant="body2" fontWeight="600">
                          {selectedOrder.customer?.name || "-"}
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 4 }}>
                        <Typography variant="body2" color="text.secondary">
                          Phone:
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 8 }}>
                        <Typography variant="body2" fontWeight="600">
                          {selectedOrder.customer?.phone || "-"}
                        </Typography>
                      </Grid>
                      {selectedOrder.customer?.address && (
                        <>
                          <Grid size={{ xs: 4 }}>
                            <Typography variant="body2" color="text.secondary">
                              Address:
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 8 }}>
                            <Typography variant="body2">
                              {selectedOrder.customer.address}
                            </Typography>
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Box> */}

                  <Box
  sx={{ flex: 1, p: 2, bgcolor: "#f8fafc", borderRadius: 2 }}
>
  <Typography
    variant="subtitle1"
    fontWeight="700"
    gutterBottom
    sx={{ display: "flex", alignItems: "center", gap: 1 }}
  >
    <Avatar
      sx={{ width: 24, height: 24, bgcolor: "primary.light" }}
    >
      👤
    </Avatar>
    Customer Information
  </Typography>
  <Divider sx={{ mb: 2 }} />
  <Grid container spacing={1.5}>
    <Grid size={{ xs: 4 }}>
      <Typography variant="body2" color="text.secondary">
        Name:
      </Typography>
    </Grid>
    <Grid size={{ xs: 8 }}>
      <Typography variant="body2" fontWeight="600">
        {selectedOrder.customer?.name || "-"}
      </Typography>
    </Grid>

    {/* ⭐ Phone Number & Call Button */}
    <Grid size={{ xs: 4 }}>
      <Typography variant="body2" color="text.secondary">
        Phone:
      </Typography>
    </Grid>
    <Grid size={{ xs: 8 }} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <Typography variant="body2" fontWeight="600">
        {selectedOrder.customer?.phone || "-"}
      </Typography>
      
      {/* Agar phone number hai tabhi button show hoga */}
      {selectedOrder.customer?.phone && (
        <Button
          size="small"
          variant="contained"
          color="success"
          href={`tel:${selectedOrder.customer.phone.replace(/\D/g, "")}`}
          startIcon={<PhoneIcon sx={{ fontSize: "14px !important" }} />}
          sx={{
            textTransform: "none",
            borderRadius: 1.5,
            height: 24,
            fontSize: "0.7rem",
            px: 1.5,
            bgcolor: "#2e7d32",
            boxShadow: "none",
            "&:hover": { 
              bgcolor: "#1b5e20",
              boxShadow: "none",
            },
          }}
        >
          Call
        </Button>
      )}
    </Grid>

    {selectedOrder.customer?.address && (
      <>
        <Grid size={{ xs: 4 }}>
          <Typography variant="body2" color="text.secondary">
            Address:
          </Typography>
        </Grid>
        <Grid size={{ xs: 8 }}>
          <Typography variant="body2">
            {selectedOrder.customer.address}
          </Typography>
        </Grid>
      </>
    )}
  </Grid>
</Box>

                  <Box
                    sx={{ flex: 1, p: 2, bgcolor: "#f8fafc", borderRadius: 2 }}
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight="700"
                      gutterBottom
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <Avatar
                        sx={{ width: 24, height: 24, bgcolor: "info.light" }}
                      >
                        📦
                      </Avatar>
                      Order Information
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <Grid container spacing={1.5}>
                      <Grid size={{ xs: 4 }}>
                        <Typography variant="body2" color="text.secondary">
                          Order Type:
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 8 }}>
                        {getOrderTypeChip(selectedOrder.orderType)}
                      </Grid>
                      {selectedOrder.tableNumber && (
                        <>
                          <Grid size={{ xs: 4 }}>
                            <Typography variant="body2" color="text.secondary">
                              Table:
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 8 }}>
                            <Chip
                              label={`Table ${selectedOrder.tableNumber}`}
                              size="small"
                              color="primary"
                              variant="outlined"
                            />
                          </Grid>
                        </>
                      )}
                      <Grid size={{ xs: 4 }}>
                        <Typography variant="body2" color="text.secondary">
                          Order Status:
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 8 }}>
                        {getStatusChip(selectedOrder.status)}
                      </Grid>
                      <Grid size={{ xs: 4 }}>
                        <Typography variant="body2" color="text.secondary">
                          Order Date:
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 8 }}>
                        <Typography variant="body2">
                          {formatDate(selectedOrder.createdAt)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>

                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="700"
                    gutterBottom
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <Avatar
                      sx={{ width: 24, height: 24, bgcolor: "success.light" }}
                    >
                      💰
                    </Avatar>
                    Payment Information
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Paper sx={{ p: 2, bgcolor: "#f8fafc", borderRadius: 2 }}>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 6, md: 3 }}>
                        <Typography variant="body2" color="text.secondary">
                          Payment Method:
                        </Typography>
                        <Typography variant="body1" fontWeight="600">
                          {getOrderPayment(selectedOrder._id)?.method ||
                            selectedOrder.paymentMethod ||
                            "Not Set"}
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 6, md: 3 }}>
                        <Typography variant="body2" color="text.secondary">
                          Payment Status:
                        </Typography>
                        <Box sx={{ mt: 0.5 }}>
                          {getPaymentStatusChip(
                            getOrderPayment(selectedOrder._id)?.status ||
                              selectedOrder.paymentStatus ||
                              "PENDING",
                          )}
                        </Box>
                      </Grid>
                      <Grid size={{ xs: 6, md: 3 }}>
                        <Typography variant="body2" color="text.secondary">
                          Paid Amount:
                        </Typography>
                        <Typography
                          variant="body1"
                          fontWeight="700"
                          color="success.main"
                        >
                          {formatCurrency(
                            getOrderPayment(selectedOrder._id)?.amount ||
                              selectedOrder.orderSummary?.paidAmount ||
                              getOrderTotal(selectedOrder),
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Paper>
                </Box>

                {/* Applied Offers */}
                {selectedOrder.appliedOffers &&
                  selectedOrder.appliedOffers.length > 0 && (
                    <Box sx={{ mb: 3 }}>
                      <Typography
                        variant="subtitle1"
                        fontWeight="700"
                        gutterBottom
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Avatar
                          sx={{
                            width: 24,
                            height: 24,
                            bgcolor: "success.light",
                          }}
                        >
                          🏷️
                        </Avatar>
                        Applied Offers
                      </Typography>
                      <Divider sx={{ mb: 2 }} />
                      <Grid container spacing={1.5}>
                        {selectedOrder.appliedOffers.map((offer, idx) => (
                          <Grid size={{ xs: 12 }} key={idx}>
                            <Paper
                              sx={{
                                p: 1.5,
                                bgcolor: "#e8f5e9",
                                borderRadius: 2,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Box display="flex" alignItems="center" gap={1.5}>
                                <OfferIcon
                                  sx={{ color: "#2e7d32", fontSize: 20 }}
                                />
                                <Box>
                                  <Typography
                                    variant="body2"
                                    fontWeight="700"
                                    sx={{ color: "#2e7d32" }}
                                  >
                                    {offer.offerCode}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    {offer.offerTitle || offer.description}
                                  </Typography>
                                </Box>
                              </Box>
                              <Chip
                                label={`-${formatCurrency(offer.discountAmount)}`}
                                size="small"
                                color="success"
                                sx={{ fontWeight: 700 }}
                              />
                            </Paper>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  )}

                {/* Items */}
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="700"
                    gutterBottom
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <Avatar
                      sx={{ width: 24, height: 24, bgcolor: "warning.light" }}
                    >
                      🍽️
                    </Avatar>
                    Order Items
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <TableContainer
                    component={Paper}
                    variant="outlined"
                    sx={{ borderRadius: 2 }}
                  >
                    <Table size="small">
                      <TableHead sx={{ bgcolor: "#f5f5f5" }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 700 }}>#</TableCell>
                          <TableCell sx={{ fontWeight: 700 }}>Item</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 700 }}>
                            Qty
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 700 }}>
                            Price
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 700 }}>
                            Total
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedOrder.items.map((item, index) => {
                          const itemTotal =
                            item.total || calculateItemTotal(item);
                          return (
                            <TableRow key={index} hover>
                              <TableCell>#{index + 1}</TableCell>
                              <TableCell>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  gap={1.5}
                                >
                                  <Avatar
                                    src={item.itemId?.image}
                                    sx={{
                                      width: 40,
                                      height: 40,
                                      borderRadius: 1.5,
                                    }}
                                    variant="rounded"
                                  >
                                    {item.itemName?.charAt(0)}
                                  </Avatar>
                                  <Box>
                                    <Typography
                                      variant="body2"
                                      fontWeight="600"
                                    >
                                      {item.itemName}
                                    </Typography>
                                    {item.selectedSize?.name && (
                                      <Typography
                                        variant="caption"
                                        display="block"
                                        color="primary.main"
                                        sx={{ fontSize: "0.7rem" }}
                                      >
                                        Size: {item.selectedSize.name} (₹
                                        {item.selectedSize.price})
                                      </Typography>
                                    )}
                                    {item.selectedVariant?.name && (
                                      <Typography
                                        variant="caption"
                                        display="block"
                                        color="secondary.main"
                                        sx={{ fontSize: "0.7rem" }}
                                      >
                                        Variant: {item.selectedVariant.name} (+₹
                                        {item.selectedVariant.price})
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell align="right">
                                <Chip
                                  label={item.quantity}
                                  size="small"
                                  sx={{ fontWeight: 700, minWidth: 35 }}
                                />
                              </TableCell>
                              <TableCell align="right">
                                {item.appliedOffer?.discountAmount > 0 ? (
                                  <Box sx={{ textAlign: "right" }}>
                                    <Typography
                                      variant="caption"
                                      sx={{
                                        display: "block",
                                        textDecoration: "line-through",
                                        color: "#999",
                                        fontSize: "0.7rem",
                                      }}
                                    >
                                      ₹{item.originalPrice || item.price || 0}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      fontWeight="700"
                                      color="success.main"
                                    >
                                      ₹{item.price || 0}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Typography variant="body2">
                                    ₹
                                    {item.price ||
                                      item.selectedSize?.price ||
                                      0}
                                  </Typography>
                                )}
                              </TableCell>
                              <TableCell align="right">
                                {item.appliedOffer?.discountAmount > 0 ? (
                                  <Box sx={{ textAlign: "right" }}>
                                    <Typography
                                      variant="caption"
                                      sx={{
                                        display: "block",
                                        textDecoration: "line-through",
                                        color: "#999",
                                        fontSize: "0.7rem",
                                      }}
                                    >
                                      ₹
                                      {(
                                        (item.originalPrice ||
                                          item.price ||
                                          0) * item.quantity
                                      ).toFixed(2)}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      fontWeight="700"
                                      color="success.main"
                                    >
                                      ₹{itemTotal.toFixed(2)}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Typography
                                    variant="body2"
                                    fontWeight="700"
                                    color="primary.main"
                                  >
                                    ₹{itemTotal.toFixed(2)}
                                  </Typography>
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                {/* Free items */}
                {selectedOrder.freeItems &&
                  selectedOrder.freeItems.length > 0 && (
                    <Box sx={{ mb: 3 }}>
                      <Typography
                        variant="subtitle1"
                        fontWeight="700"
                        gutterBottom
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Avatar
                          sx={{
                            width: 24,
                            height: 24,
                            bgcolor: "success.light",
                          }}
                        >
                          🎁
                        </Avatar>
                        Free Items
                      </Typography>
                      <Divider sx={{ mb: 2 }} />
                      <Grid container spacing={1.5}>
                        {selectedOrder.freeItems.map((item, idx) => (
                          <Grid size={{ xs: 12, sm: 6 }} key={idx}>
                            <Paper
                              sx={{
                                p: 1.5,
                                bgcolor: "#e8f5e9",
                                borderRadius: 2,
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                              }}
                            >
                              <Avatar
                                src={item.itemId?.image}
                                sx={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: 1.5,
                                }}
                              />
                              <Box>
                                <Typography variant="body2" fontWeight="600">
                                  {item.itemName} × {item.quantity}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="success.main"
                                  fontWeight="700"
                                >
                                  FREE (₹{item.price} saved)
                                </Typography>
                              </Box>
                            </Paper>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  )}

                {/* Payment Summary */}
                <Box sx={{ mt: 3 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="700"
                    gutterBottom
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <Avatar sx={{ width: 24, height: 24, bgcolor: "info.light" }}>
                      💰
                    </Avatar>
                    Payment Summary
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Paper sx={{ p: 2, bgcolor: "#f8fafc", borderRadius: 2 }}>
                    <Grid container spacing={1.5}>
                      <Grid size={{ xs: 6 }}>
                        <Typography variant="body2" color="text.secondary">
                          Subtotal:
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 6 }}>
                        <Typography
                          variant="body2"
                          align="right"
                          fontWeight="500"
                        >
                          {formatCurrency(getOrderSubtotal(selectedOrder))}
                        </Typography>
                      </Grid>

                      {/* Total Discount */}
                      {selectedOrder.orderSummary?.totalDiscount > 0 && (
                        <>
                          <Grid size={{ xs: 6 }}>
                            <Typography variant="body2" color="success.main">
                              Total Discount:
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 6 }}>
                            <Typography
                              variant="body2"
                              align="right"
                              fontWeight="700"
                              color="success.main"
                            >
                              -
                              {formatCurrency(
                                selectedOrder.orderSummary.totalDiscount,
                              )}
                            </Typography>
                          </Grid>
                        </>
                      )}

                      {/* Delivery Charge */}
                      {selectedOrder.orderType === "DELIVERY" && (
                        <>
                          <Grid size={{ xs: 6 }}>
                            <Typography variant="body2" color="text.secondary">
                              Delivery Charge:
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 6 }}>
                            <Typography
                              variant="body2"
                              align="right"
                              fontWeight="600"
                              color={
                                getOrderDeliveryCharge(selectedOrder) === 0
                                  ? "success.main"
                                  : "text.primary"
                              }
                            >
                              {getOrderDeliveryCharge(selectedOrder) === 0
                                ? "FREE"
                                : formatCurrency(
                                    getOrderDeliveryCharge(selectedOrder),
                                  )}
                            </Typography>
                          </Grid>
                        </>
                      )}

                      <Grid size={{ xs: 12 }}>
                        <Divider sx={{ my: 0.5 }} />
                      </Grid>

                      <Grid size={{ xs: 6 }}>
                        <Typography variant="h6" fontWeight="700">
                          Total:
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 6 }}>
                        <Typography
                          variant="h6"
                          align="right"
                          fontWeight="700"
                          color="primary.main"
                        >
                          {formatCurrency(getOrderTotal(selectedOrder))}
                        </Typography>
                      </Grid>

                      {Number(selectedOrder.orderSummary?.refundDue || 0) > 0 && (
                        <Grid size={{ xs: 12 }}>
                          <Box
                            sx={{
                              mt: 1.5,
                              p: 2,
                              bgcolor: "#ffebee",
                              borderRadius: 2,
                              border: "1.5px solid #ef5350",
                              display: "flex",
                              flexDirection: { xs: "column", sm: "row" },
                              justifyContent: "space-between",
                              alignItems: { xs: "flex-start", sm: "center" },
                              gap: 1.5,
                            }}
                          >
                            <Box>
                              <Typography
                                variant="subtitle2"
                                fontWeight={800}
                                color="#c62828"
                              >
                                ⚠ Action Required: Refund ₹
                                {Number(
                                  selectedOrder.orderSummary.refundDue,
                                ).toFixed(2)}{" "}
                                to Customer
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                Customer reduced items or cancelled order. Please issue refund via UPI/Cash and confirm below.
                              </Typography>
                            </Box>

                            <Button
                              variant="contained"
                              color="success"
                              size="small"
                              onClick={async () => {
                                try {
                                  const res = await axiosInstance.put(
                                    `/api/orders/${selectedOrder._id}/settle-refund`,
                                  );
                                  if (res.data.success) {
                                    setSelectedOrder(res.data.order);
                                    fetchOrders(false);
                                    dispatch(fetchOrderStats());
                                  }
                                } catch (err) {
                                  console.error(
                                    "Failed to settle refund:",
                                    err,
                                  );
                                }
                              }}
                              sx={{
                                borderRadius: 2,
                                fontWeight: 700,
                                textTransform: "none",
                                bgcolor: "#2e7d32",
                                "&:hover": { bgcolor: "#1b5e20" },
                                whiteSpace: "nowrap",
                              }}
                            >
                              Mark as Refunded ✅
                            </Button>
                          </Box>
                        </Grid>
                      )}

                      {selectedOrder.orderSummary?.totalDiscount > 0 && (
                        <Grid size={{ xs: 12 }}>
                          <Typography
                            variant="caption"
                            color="success.main"
                            sx={{ display: "block", textAlign: "right" }}
                          >
                            🎉 Customer saved{" "}
                            {formatCurrency(
                              selectedOrder.orderSummary.totalDiscount,
                            )}
                            !
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                  </Paper>
                </Box>
              </>
            )}
          </DialogContent>
          <DialogActions
            sx={{ p: 2, borderTop: "1px solid", borderColor: "divider" }}
          >
            <Button
              onClick={() => setOpenViewDialog(false)}
              variant="contained"
              sx={{ borderRadius: 2 }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Edit Order Dialog */}
        <Dialog
          open={openEditDialog}
          onClose={() => setOpenEditDialog(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle
            sx={{ borderBottom: "1px solid", borderColor: "divider" }}
          >
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar sx={{ bgcolor: "secondary.main" }}>
                <EditIcon />
              </Avatar>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  Edit Order #{selectedOrder?._id?.slice(-8).toUpperCase()}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Order ID: {selectedOrder?._id}
                </Typography>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            <Grid container spacing={2} mt={1}>
              {/* ⭐ 1. Order Type Dropdown */}
              <Grid size={{ xs: 12, md: 4 }}>
                <FormControl fullWidth size="small">
                  <InputLabel>Order Type</InputLabel>
                  <Select
                    value={orderData.orderType}
                    label="Order Type"
                    onChange={(e) =>
                      setOrderData({ ...orderData, orderType: e.target.value })
                    }
                  >
                    <MenuItem value="DINE_IN">Dine In (DINE_IN)</MenuItem>
                    <MenuItem value="TAKEAWAY">Takeaway (TAKEAWAY)</MenuItem>
                    <MenuItem value="DELIVERY">Delivery (DELIVERY)</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label="Customer Name"
                  value={orderData.name}
                  onChange={(e) =>
                    setOrderData({ ...orderData, name: e.target.value })
                  }
                  size="small"
                  variant="outlined"
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label="Phone Number"
                  value={orderData.phone}
                  onChange={(e) =>
                    setOrderData({ ...orderData, phone: e.target.value })
                  }
                  size="small"
                  variant="outlined"
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="Address"
                  multiline
                  rows={2}
                  value={orderData.address}
                  onChange={(e) =>
                    setOrderData({ ...orderData, address: e.target.value })
                  }
                  size="small"
                  variant="outlined"
                />
              </Grid>

              {/* Items list section */}
              <Grid size={{ xs: 12 }}>
                <Typography
                  variant="subtitle1"
                  fontWeight="700"
                  gutterBottom
                  sx={{ mt: 1 }}
                >
                  Order Items
                </Typography>
                <Divider sx={{ mb: 2 }} />
                {orderData?.items && orderData.items.length > 0 ? (
                  <Box sx={{ maxHeight: "35vh", overflow: "auto", pr: 1 }}>
                    {orderData.items.map((item, index) => (
                      <Paper
                        key={item._id || index}
                        variant="outlined"
                        sx={{
                          p: 2,
                          mb: 2,
                          borderRadius: 2,
                          borderLeft:
                            item.appliedOffer?.discountAmount > 0
                              ? "4px solid #4caf50"
                              : "1px solid #e0e0e0",
                        }}
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          mb={1.5}
                        >
                          <Box display="flex" alignItems="center" gap={1.5}>
                            <Avatar
                              src={item.itemId?.image}
                              sx={{ width: 40, height: 40, borderRadius: 1.5 }}
                            />
                            <Box>
                              <Typography variant="subtitle2" fontWeight="700">
                                {item.itemName}
                              </Typography>
                              {item.appliedOffer?.discountAmount > 0 && (
                                <Chip
                                  label={`Offer: ${item.appliedOffer.offerCode}`}
                                  size="small"
                                  sx={{
                                    height: 18,
                                    fontSize: "0.6rem",
                                    bgcolor: "#e8f5e9",
                                    color: "#2e7d32",
                                  }}
                                />
                              )}
                            </Box>
                          </Box>

                          {/* Delete Item Button */}
                          <Tooltip title="Delete Item">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleRemoveItem(index)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>

                        {/* Selected Size / Variant / Addons labels */}
                        {item.selectedSize?.name && (
                          <Box
                            sx={{
                              mb: 1,
                              p: 0.8,
                              bgcolor: "#e3f2fd",
                              borderRadius: 1,
                            }}
                          >
                            <Typography
                              variant="caption"
                              fontWeight="600"
                              color="primary.main"
                            >
                              Size: {item.selectedSize.name} (₹{item.selectedSize.price})
                            </Typography>
                          </Box>
                        )}
                        {item.selectedVariant?.name && (
                          <Box
                            sx={{
                              mb: 1,
                              p: 0.8,
                              bgcolor: "#f3e5f5",
                              borderRadius: 1,
                            }}
                          >
                            <Typography
                              variant="caption"
                              fontWeight="600"
                              color="secondary.main"
                            >
                              Variant: {item.selectedVariant.name} (+₹{item.selectedVariant.price})
                            </Typography>
                          </Box>
                        )}
                        {item.selectedAddons?.length > 0 && (
                          <Box
                            sx={{
                              mb: 1.5,
                              p: 0.8,
                              bgcolor: "#e8f5e9",
                              borderRadius: 1,
                            }}
                          >
                            <Typography
                              variant="caption"
                              fontWeight="600"
                              color="success.main"
                              gutterBottom
                            >
                              Addons:
                            </Typography>
                            {item.selectedAddons.map((addon, i) => (
                              <Typography
                                key={i}
                                variant="caption"
                                display="block"
                                sx={{ ml: 1 }}
                              >
                                • {addon.name}: +₹{addon.price}
                              </Typography>
                            ))}
                          </Box>
                        )}

                        <Grid container spacing={2} alignItems="center">
                          <Grid size={{ xs: 6 }}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Quantity"
                              type="number"
                              value={item.quantity}
                              onChange={(e) => {
                                const newItems = [...orderData.items];
                                const quantity = parseInt(e.target.value) || 0;
                                newItems[index] = {
                                  ...newItems[index],
                                  quantity,
                                  total: calculateItemTotal({
                                    ...newItems[index],
                                    quantity,
                                  }),
                                };
                                setOrderData({
                                  ...orderData,
                                  items: newItems,
                                  totalAmount: calculateTotalAmount(
                                    newItems,
                                    orderData.deliveryCharge,
                                  ),
                                });
                              }}
                              InputProps={{ inputProps: { min: 1 } }}
                            />
                          </Grid>
                          <Grid size={{ xs: 6 }}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Price"
                              type="number"
                              value={
                                item.price || item.selectedSize?.price || 0
                              }
                              onChange={(e) => {
                                const newItems = [...orderData.items];
                                const priceVal = Number(e.target.value) || 0;
                                newItems[index] = {
                                  ...newItems[index],
                                  price: priceVal,
                                  total: priceVal * (newItems[index].quantity || 1),
                                };
                                setOrderData({
                                  ...orderData,
                                  items: newItems,
                                  totalAmount: calculateTotalAmount(
                                    newItems,
                                    orderData.deliveryCharge,
                                  ),
                                });
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    ₹
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                        </Grid>

                        <Box display="flex" justifyContent="flex-end" mt={1.5}>
                          <Typography
                            variant="body2"
                            color="primary.main"
                            fontWeight="700"
                          >
                            Subtotal: ₹{item.total || calculateItemTotal(item)}
                          </Typography>
                        </Box>
                      </Paper>
                    ))}
                  </Box>
                ) : (
                  <Typography
                    color="text.secondary"
                    align="center"
                    sx={{ py: 4 }}
                  >
                    No items in this order
                  </Typography>
                )}
              </Grid>

              {/* ⭐ 2. NAYA ITEM ADD KARNE KA SECTION (With Auto Price, Sizes, Variants, Addons) */}
              <Grid size={{ xs: 12 }}>
                <Typography
                  variant="subtitle1"
                  fontWeight="700"
                  gutterBottom
                  sx={{ mt: 1 }}
                >
                  Add Menu Item
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, bgcolor: "#f0f7ff" }}>
                  <Grid container spacing={2} alignItems="center">
                    {/* Item Name / Search Autocomplete from API */}
                    <Grid size={{ xs: 12, sm: 5 }}>
                      <Autocomplete
                        options={availableMenuItems}
                        getOptionLabel={(option) =>
                          option.itemName
                            ? `${option.itemName} (₹${option.basePrice || option.price || 0})`
                            : ""
                        }
                        value={newItem.selectedMenu}
                        onChange={(event, newValue) => {
                          handleSelectMenuItem(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Menu Item"
                            size="small"
                            placeholder="Choose from restaurant menu..."
                          />
                        )}
                      />
                    </Grid>

                    {/* Price (Auto-filled & Editable) */}
                    <Grid size={{ xs: 6, sm: 3 }}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Price (₹)"
                        type="number"
                        value={newItem.price || ""}
                        onChange={(e) =>
                          setNewItem({ ...newItem, price: Number(e.target.value) })
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">₹</InputAdornment>
                          ),
                        }}
                      />
                    </Grid>

                    {/* Quantity */}
                    <Grid size={{ xs: 6, sm: 2 }}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Qty"
                        type="number"
                        value={newItem.quantity}
                        onChange={(e) =>
                          setNewItem({ ...newItem, quantity: Number(e.target.value) })
                        }
                        InputProps={{ inputProps: { min: 1 } }}
                      />
                    </Grid>

                    {/* Add Button */}
                    <Grid size={{ xs: 12, sm: 2 }}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="success"
                        startIcon={<AddIcon />}
                        onClick={handleAddNewItem}
                        disabled={!newItem.itemName || newItem.price <= 0}
                        sx={{ borderRadius: 2, height: "40px" }}
                      >
                        Add
                      </Button>
                    </Grid>

                    {/* SIZES DROPDOWN (Agar Item me Sizes hain) */}
                    {newItem.selectedMenu?.sizes && newItem.selectedMenu.sizes.length > 0 && (
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Size</InputLabel>
                          <Select
                            value={newItem.selectedSize?.name || ""}
                            label="Size"
                            onChange={(e) => handleSizeChange(e.target.value)}
                          >
                            <MenuItem value="">-- Default Base Price --</MenuItem>
                            {newItem.selectedMenu.sizes.map((s, idx) => (
                              <MenuItem key={idx} value={s.name}>
                                {s.name} (₹{s.price})
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}

                    {/* VARIANTS DROPDOWN (Agar Item me Variants hain) */}
                    {newItem.selectedMenu?.variants && newItem.selectedMenu.variants.length > 0 && (
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Variant</InputLabel>
                          <Select
                            value={newItem.selectedVariant?.name || ""}
                            label="Variant"
                            onChange={(e) => handleVariantChange(e.target.value)}
                          >
                            <MenuItem value="">-- None / Default --</MenuItem>
                            {newItem.selectedMenu.variants.map((v, idx) => (
                              <MenuItem key={idx} value={v.name}>
                                {v.name} (+₹{v.price || 0})
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}

                    {/* ADDON GROUPS (Agar Item me Addon Groups hain) */}
                    {newItem.selectedMenu?.addonGroups && newItem.selectedMenu.addonGroups.length > 0 && (
                      <Grid size={{ xs: 12 }}>
                        <Box sx={{ p: 1.5, bgcolor: "#fff", borderRadius: 2, border: "1px dashed #90caf9" }}>
                          <Typography variant="caption" sx={{ fontWeight: 700, color: "primary.main" }} display="block">
                            Addon Groups:
                          </Typography>
                          {newItem.selectedMenu.addonGroups.map((grp, gIdx) => (
                            <Box key={gIdx} sx={{ mt: 0.5 }}>
                              <Typography variant="caption" sx={{ fontWeight: 600 }}>
                                {grp.groupName}:
                              </Typography>
                              <FormGroup row>
                                {grp.items?.map((ad, aIdx) => {
                                  const isChecked = newItem.selectedAddons.some((a) => a.name === ad.name);
                                  return (
                                    <FormControlLabel
                                      key={aIdx}
                                      control={
                                        <Checkbox
                                          size="small"
                                          checked={isChecked}
                                          onChange={() => handleAddonToggle(ad)}
                                        />
                                      }
                                      label={
                                        <Typography variant="caption">
                                          {ad.name} (+₹{ad.price})
                                        </Typography>
                                      }
                                    />
                                  );
                                })}
                              </FormGroup>
                            </Box>
                          ))}
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Paper>
              </Grid>

              {/* Delivery Charge Edit (if DELIVERY order) */}
              {orderData.orderType === "DELIVERY" && (
                <Grid size={{ xs: 12, md: 6 }}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Delivery Charge"
                    type="number"
                    value={orderData.deliveryCharge}
                    onChange={(e) => {
                      const dCharge = Number(e.target.value) || 0;
                      setOrderData({
                        ...orderData,
                        deliveryCharge: dCharge,
                        totalAmount: calculateTotalAmount(
                          orderData.items,
                          dCharge,
                        ),
                      });
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">₹</InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              )}

              {/* Total Summary Paper */}
              <Grid size={{ xs: 12 }}>
                <Paper
                  sx={{ p: 2, mt: 1, bgcolor: "#f8fafc", borderRadius: 2 }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>
                      Total Amount:
                    </Typography>
                    <Box textAlign="right">
                      {selectedOrder?.orderSummary?.totalDiscount > 0 && (
                        <Typography
                          variant="body2"
                          sx={{ color: "#999", textDecoration: "line-through" }}
                        >
                          {formatCurrency(selectedOrder.orderSummary.subtotal)}
                        </Typography>
                      )}
                      <Typography
                        variant="h5"
                        color="primary.main"
                        fontWeight="700"
                      >
                        {formatCurrency(orderData.totalAmount)}
                      </Typography>
                      {selectedOrder?.orderSummary?.totalDiscount > 0 && (
                        <Typography
                          variant="caption"
                          color="success.main"
                          sx={{ display: "block" }}
                        >
                          Discount: -
                          {formatCurrency(
                            selectedOrder.orderSummary.totalDiscount,
                          )}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Paper>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label="Notes"
                  multiline
                  rows={2}
                  value={orderData.notes}
                  onChange={(e) =>
                    setOrderData({ ...orderData, notes: e.target.value })
                  }
                  placeholder="Add any special instructions or notes..."
                  size="small"
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            sx={{ p: 2, borderTop: "1px solid", borderColor: "divider" }}
          >
            <Button
              onClick={() => setOpenEditDialog(false)}
              variant="outlined"
              sx={{ borderRadius: 2 }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleUpdateOrder}
              variant="contained"
              color="primary"
              disabled={loading}
              sx={{ borderRadius: 2 }}
            >
              {loading ? <CircularProgress size={24} /> : "Update Order"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Delete Dialog */}
        <Dialog
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ bgcolor: "#ffebee", py: 2 }}>
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar sx={{ bgcolor: "error.main" }}>
                <CancelIcon />
              </Avatar>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: "error.main" }}
              >
                Cancel Order
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            <Alert severity="warning" sx={{ mb: 2, borderRadius: 2 }}>
              This action cannot be undone. The order will be cancelled
              permanently.
            </Alert>
            <Typography variant="body1" gutterBottom>
              Are you sure you want to cancel this order?
            </Typography>
            {selectedOrder && (
              <Paper
                variant="outlined"
                sx={{ p: 2, mt: 2, bgcolor: "#fafafa", borderRadius: 2 }}
              >
                <Typography variant="subtitle2" fontWeight="700" gutterBottom>
                  Order Summary:
                </Typography>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 6 }}>
                    <Typography variant="body2" color="text.secondary">
                      Order ID:
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }}>
                    <Typography variant="body2" fontWeight="600">
                      {selectedOrder._id?.slice(-8).toUpperCase()}
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }}>
                    <Typography variant="body2" color="text.secondary">
                      Items:
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }}>
                    <Typography variant="body2" fontWeight="600">
                      {calculateTotalItems(selectedOrder.items)} items
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }}>
                    <Typography variant="body2" color="text.secondary">
                      Total:
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }}>
                    <Typography
                      variant="body2"
                      fontWeight="700"
                      color="error.main"
                    >
                      {formatCurrency(getOrderTotal(selectedOrder))}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button
              onClick={() => setOpenDeleteDialog(false)}
              variant="outlined"
              sx={{ borderRadius: 2 }}
            >
              No, Keep Order
            </Button>
            <Button
              onClick={handleConfirmDelete}
              variant="contained"
              color="error"
              disabled={loading}
              sx={{ borderRadius: 2 }}
            >
              {loading ? <CircularProgress size={24} /> : "Yes, Cancel Order"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Status Dialog */}
        <Dialog
          open={openStatusDialog}
          onClose={() => setOpenStatusDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{ borderBottom: "1px solid", borderColor: "divider" }}
          >
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar sx={{ bgcolor: "info.main" }}>
                <TimelineIcon />
              </Avatar>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Update Order Status
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            {selectedOrder && (
              <Box sx={{ mb: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Current Status:
                </Typography>
                {getStatusChip(selectedOrder.status)}
              </Box>
            )}
            <FormControl fullWidth sx={{ mt: 1 }}>
              <InputLabel>New Status</InputLabel>
              <Select
                value={newStatus}
                label="New Status"
                onChange={(e) => setNewStatus(e.target.value)}
              >
                {statusOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    <Box display="flex" alignItems="center" gap={1}>
                      {getStatusIcon(option.value)}
                      <Typography>{option.label}</Typography>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions
            sx={{ p: 2, borderTop: "1px solid", borderColor: "divider" }}
          >
            <Button
              onClick={() => setOpenStatusDialog(false)}
              variant="outlined"
              sx={{ borderRadius: 2 }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleStatusUpdate}
              variant="contained"
              color="primary"
              disabled={
                loading || !newStatus || newStatus === selectedOrder?.status
              }
              sx={{ borderRadius: 2 }}
            >
              {loading ? <CircularProgress size={24} /> : "Update Status"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Update Payment Status Dialog */}
        <Dialog
          open={openPaymentStatusDialog}
          onClose={() => setOpenPaymentStatusDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar sx={{ bgcolor: "success.main" }}>
                <PaymentIcon />
              </Avatar>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Update Payment Status
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            {selectedOrder && (
              <Box sx={{ mb: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Order: {selectedOrder._id?.slice(-8).toUpperCase()}
                </Typography>
                <Typography variant="body1" fontWeight="600">
                  Amount: {formatCurrency(getOrderTotal(selectedOrder))}
                </Typography>
              </Box>
            )}
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>Payment Status</InputLabel>
              <Select
                value={newPaymentStatus}
                label="Payment Status"
                onChange={(e) => setNewPaymentStatus(e.target.value)}
              >
                {paymentStatusOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    <Box display="flex" alignItems="center" gap={1}>
                      {option.value === "PAID" && (
                        <CheckCircleIcon
                          sx={{ color: "success.main" }}
                          fontSize="small"
                        />
                      )}
                      {option.value === "PENDING" && (
                        <PendingIcon
                          sx={{ color: "warning.main" }}
                          fontSize="small"
                        />
                      )}
                      {option.value === "FAILED" && (
                        <CancelIcon
                          sx={{ color: "error.main" }}
                          fontSize="small"
                        />
                      )}
                      {option.value === "REFUND_PENDING" && (
                        <RefundIcon
                          sx={{ color: "error.main" }}
                          fontSize="small"
                        />
                      )}
                      {option.value === "REFUNDED" && (
                        <PaymentIcon
                          sx={{ color: "info.main" }}
                          fontSize="small"
                        />
                      )}
                      <Typography>{option.label}</Typography>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions
            sx={{ p: 2, borderTop: "1px solid", borderColor: "divider" }}
          >
            <Button
              onClick={() => setOpenPaymentStatusDialog(false)}
              variant="outlined"
              sx={{ borderRadius: 2 }}
            >
              Cancel
            </Button>
            <Button
              onClick={handlePaymentStatusDialogUpdate}
              variant="contained"
              color="success"
              disabled={!newPaymentStatus}
              sx={{ borderRadius: 2 }}
            >
              Update Payment
            </Button>
          </DialogActions>
        </Dialog>

        {/* Date Range Dialog */}
        <Dialog
          open={openDateRangeDialog}
          onClose={() => setOpenDateRangeDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar sx={{ bgcolor: "primary.main" }}>
                <DateRangeIcon />
              </Avatar>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Select Date Range
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            <DatePicker
              label="Start Date"
              value={dateRange.startDate}
              onChange={(newValue) =>
                setDateRange({ ...dateRange, startDate: newValue })
              }
              slotProps={{
                textField: {
                  fullWidth: true,
                  margin: "normal",
                  size: "small",
                  sx: { mb: 2 },
                },
              }}
            />
            <DatePicker
              label="End Date"
              value={dateRange.endDate}
              onChange={(newValue) =>
                setDateRange({ ...dateRange, endDate: newValue })
              }
              slotProps={{
                textField: {
                  fullWidth: true,
                  margin: "normal",
                  size: "small",
                },
              }}
            />
          </DialogContent>
          <DialogActions
            sx={{ p: 2, borderTop: "1px solid", borderColor: "divider" }}
          >
            <Button
              onClick={() => setOpenDateRangeDialog(false)}
              variant="outlined"
              sx={{ borderRadius: 2 }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleDateRangeApply}
              variant="contained"
              color="primary"
              disabled={!dateRange.startDate || !dateRange.endDate}
              sx={{ borderRadius: 2 }}
            >
              Apply Filter
            </Button>
          </DialogActions>
        </Dialog>

        {/* Snackbars */}
        <Snackbar
          open={!!error}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity="error"
            variant="filled"
            sx={{ width: "100%", borderRadius: 2 }}
          >
            {error}
          </Alert>
        </Snackbar>

        <Snackbar
          open={!!success}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity="success"
            variant="filled"
            sx={{ width: "100%", borderRadius: 2 }}
          >
            {success === true ? "Operation completed successfully!" : success}
          </Alert>
        </Snackbar>
      </Box>
    </LocalizationProvider>
  );
};

export default Orders;